function validationNoGreaterThan(
    $el,
  ) {
    // Put form into context.
    let parentForm = $el.parents('form');
    // Get the max length config.
    let maxLength = $el.attr('data-max-length');
    // Get the input length.
    let inputLength = $el.val().length;
    // Validate Status.
    let status = true;
    if (parseInt(inputLength) > parseInt(maxLength)) {
      status = false
      parentForm.find('.length-error').addClass('is-visible');
    } else if (parentForm.find('.length-error').hasClass('is-visable')) {
      status = true
      parentForm.find('.length-error').removeClass('is-visible');
  
    }
    return (status);
}

// ----- Configuration ----- 
// --- General --- 
// Holds all the ignored inputs regarding the validation.
const ignoredInputs = ["reset", "hidden", "color"];
// Restricted content elements ( e.g manage users ).
//const restrictedContent = '[data-restricted-content]';
// --- Custom Patterns ---
// Overrite Foundation Abide defaults with VM Validation.
var defaultValidationPatterns = {
    "email": $('input[type=email]').data('validate'),
    "url": $('input[type=url]').data('validate'),
    "date": $('input[type=date]').data('validate'),
    "datetime": $('input[type=datetime-local]').data('validate'),
    "time": $('input[type=time]').data('validate')
};

if (defaultValidationPatterns['email']) {
    Foundation.Abide.defaults.patterns['email'] = new RegExp(defaultValidationPatterns['email']);
}
if (defaultValidationPatterns['url']) {
    Foundation.Abide.defaults.patterns['url'] = new RegExp(defaultValidationPatterns['url']);
}
if (defaultValidationPatterns['date']) {
    Foundation.Abide.defaults.patterns['date'] = new RegExp(defaultValidationPatterns['date']);
}
if (defaultValidationPatterns['datetime']) {
    Foundation.Abide.defaults.patterns['datetime'] = new RegExp(defaultValidationPatterns['datetime']);
}
if (defaultValidationPatterns['time']) {
    Foundation.Abide.defaults.patterns['time'] = new RegExp(defaultValidationPatterns['time']);
}
// Max length.
Foundation.Abide.defaults.validators['max-length'] = validationNoGreaterThan;
// If a general purpose pattern is provided. 
Foundation.Abide.defaults.validators['vm-validate'] = vmValidation;
// Checkbox group min required.
Foundation.Abide.defaults.validators['min-required'] = minRequired;

Foundation.Abide.defaults.validators['max-allowed'] = maxAllowed;
// If total value is a multiple of x.
Foundation.Abide.defaults.validators['multiple-of'] = multipleValidation;
// Override default settings.
Foundation.Abide.defaults['validateOn'] = "0";

var displayGroupValidation = false;

function multipleValidation($element, required, parent) {
    // Is valid?
    let isValid = true;
    // Container.
    let container = $element.parents('[' + expressSelectors()['forms']['input-group-id'] + ']');
    // Group id.
    let groupId = container.attr(expressSelectors()['forms']['input-group-id']);
    if (!groupId) {
        AXISDebug.output(3,"Validation: Failed to run validator multiple-of due to now group id being provided.", $element);
        return false;
    }
    // Get inputs.
    let inputs = $("[" + expressSelectors()['forms']['group-id'] + "=" + groupId + "]");
    // What type of input is this?
    let type = $element.attr('type');
    // Get multple.
    let multiple = parseInt(container.attr(expressSelectors()['forms']['group-multiple']));
    if (!multiple) {
        AXISDebug.output(3,"Validation: No multiple detected are you missing the attribute on the container?", multiple);
        return false;
    }
    switch(type) {
        case "number":
            // Get toal value.
            let total = inputsTotalValue(inputs);
            console.log(total + " || " + multiple)
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Validation: Calculated the total value of all inputs in group " + groupId + " which was " + total + " and the multiple is " + multiple);
            }
            // Run check.
            if ((total != 0) && (multipleOf(total, multiple))) {
                isValid = true;
            } else {
                isValid = false;
            }
            break;
        default:
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(2,"Validation: there is no code path type " + type + " for the mutiple-of validator.");
            }
            isValid = false;
    } 

    if (!isValid && $element.attr(expressSelectors()['forms']['group-id'])) {
        displayGroupValidation = true;
    }

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, `Multiple-of validation:
        Input Name: ${$element.attr('name')}
        Multiple value: ${multiple}
        Input type: ${type}
        Is the value valid: ${isValid}
    `);
    }
    return isValid;
}

// If input type = number then counts the total value of inputs.
function maxAllowed($element, required, parent) {
    // Is valid?
    let isValid = true;
    // Container.
    let container = $element.parents('[' + expressSelectors()['forms']['input-group-id'] + ']');
    // Group id.
    let groupId = container.attr(expressSelectors()['forms']['input-group-id']);
    if (!groupId) {
        AXISDebug.output(3,"Validation: Failed to run validator max-allowed due to now group id being provided.", $element);
        return false;
    }
    // Check if this is an input.
    let isInput = $element.is('input');
    // Get inputs.
    let inputs = $("[" + expressSelectors()['forms']['group-id'] + "=" + groupId + "]");
    if (isInput) {
        // What type of input is this?
        let type = $element.attr('type');
        switch(type) {
            case "number":
                // Get max.
                let max = container.attr(expressSelectors()['forms']['group-max']);
                // Get toal value.
                let total = inputsTotalValue(inputs);
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Validation: Calculated the total value of all inputs in group " + groupId + " which was " + total + " and the max is " + max);
                }
                // Run check.
                if (total <= max) {;
                    isValid = true;
                } else {
                    isValid = false;
                }
                break;
            default:
                if (AXISDebug.level() >= 2) {
                    AXISDebug.output(2,"Validation: there is no code path type " + type + " for the max-allowed validator.");
                }
                isValid = false;
        } 
    } else {
        AXISDebug.output(2,"Validation: validator max-allowed only supports inputs at the moment.");
    }
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, `Max allowed validation:
        Input Name: ${$element.attr('name')}
        Is the value valid: ${isValid}
    `);
    }

    if (!isValid && $element.attr(expressSelectors()['forms']['group-id'])) {
        displayGroupValidation = true;
    }

    return isValid;
}


/*

Group min required.
This was original developed for checkboxes then made more generic.

Parameters:
1. input context.
2. Whether to suppress live validation.
3. Foundation passes in the label context on form submit.
4. The event that triggered this validation ( i.e when doing live validation ).

*/
function minRequired($element, liveValidation = false, labelContext = undefined, triggerEvent = "submit") {
    // Is valid?
    let isValid = true;
    // Check if input is required.
    let required = ($element.attr('required') != undefined);
    // Container.
    let container = $element.parents('[' + expressSelectors()['forms']['input-group-id'] + ']');
    // If the container is a form then enforce min required attribute.
    if (container.is('form')) {
        required = true;
    }
    // Fallback
    if (!container) {
        container = $element.parents('fieldset');
    }
    if (container.length == 0) {
        container = $element.parents('.field');
    }
    // Check wether a parent input has been configured, as that will need to be toggled before validation will be considered for child inputs.
    let parentIsInput = false;
    // Get group id.
    let groupId = container.attr(expressSelectors()['forms']['input-group-id']);
    // If no id on container check the input itself as it might be a parent input.
    if (!groupId) {
        groupId = $element.attr(expressSelectors()['forms']['input-group-id']);
        if (groupId) {
            parentIsInput = true;
        }
    }
    // One last check on the input.
    if (!groupId) {
        groupId = $element.attr(expressSelectors()['forms']['group-id']);
    }
    // Give up... output error.
    if (!groupId) {
        AXISDebug.output(3,"Validation: The data-group-id must be present for the min-required validator to work.");
        return false;
    }
    // Get min value.
    let min = container.attr(expressSelectors()['forms']['group-min']);
    // Fallback
    if (!min) {
        min = $element.attr(expressSelectors()['forms']['min-required']);
    }
    if (!min) {
        min = 1;
    }
    min = parseInt(min);

    // Check if we're suppressing live validation.
    let suppressLiveValidation = ($element.parents('form').attr(expressSelectors()['forms']['suppress-live-validation']) != undefined);

    // Is input? 
    let isInput = $element.is('input');
    // For storing inptus inputs.
    let inputs;
    // Find error message
    let error = $('[' + expressSelectors()['forms']['validation']['external-error'] + '=' + groupId + ']');
    // Parent form.
    let form = $element.parents('form');


    if (isInput) {
        // What type of input is this?
        let type = $element.attr('type');
        switch(type) {
            case "number": 
                inputs = $("[" + expressSelectors()['forms']['group-id'] + "=" + groupId + "]");
                // Get total value.
                let total = inputsTotalValue(inputs);
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Validation: Calculated the total value of all inputs in group " + groupId + " which was " + total + " and the min required is " + min);
                }
                // Run Check.
                if (total >= min) {
                    isValid = true;
                } else {
                    isValid = false;
                }
                break;
            case "radio": // Fall-through as both actions are similar.
            case "checkbox":
                // Get inputs.
                inputs = $('input[' + expressSelectors()['forms']['group-id'] + '=' + groupId + ']:not(:disabled):checked');
                // Count active value.
                let checked = inputs.length;
                // Is parent checked.
                const parentChecked = $element.prop('checked');
                // Run the test!
                if (checked >= min) {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1,"Validation: Min inputs required hit!");
                    }
                    // Clean up any invalid inputs in group.
                    $('input[' + expressSelectors()['forms']['group-id'] + '=' + groupId + ']').each(function() {
                        let item = $(this);
                        if (item.hasClass('is-invalid-input')) {
                            item.removeClass('is-invalid-input');
                            item.removeAttr("data-invalid");
                            item.removeAttr("aria-invalid");
                            item.parent('label').removeClass('is-invalid-label');
                        }
                    });
                    // Remove error state from parents.
                    const parents = $('[' + expressSelectors()['forms']['input-group-id'] + ']');
                    if (parents.length) {
                        form.foundation('removeErrorClasses', parents);
                    }
                    // Suppressing as this gets handled by validationOutput().
                    // Remove invalid class from form.
                    // if (form.length > 0) {
                    //     form.removeClass('is-invalid');
                    // }
                    if (error.length > 0 && error.hasClass('is-visible')) {
                        error.removeClass('is-visible');
                    }
                    isValid = true;
                } else {
                    /*
                    
                        This was modified so if the parent element was unchecked then ignore it's child inputs. Think min selected functionality for selecting branches for manage users, if not allowed to login at all then this group will be completed skipped over when validation is run. 
                    
                    */
                    if (required || parentChecked && triggerEvent == "submit") {
                        // if (triggerEvent == "submit") {
                            isValid = false;
                        // }
                    } else if (!parentIsInput && triggerEvent == "submit") {
                        // If not in a group the min-requred == always required.
                        isValid = false;
                    }
                    // Suppress error message if this is a live validation validate call && we'res suppress live validation.
                    if ((!liveValidation && suppressLiveValidation) || !suppressLiveValidation) {
                        if (error.length > 0 && !error.hasClass('is-visible') && triggerEvent == "submit") {
                            error.addClass('is-visible');
                        }
                    }
                    
                }
                break;
        default:
            // Defaulting to x ( data-group-min ) number of fields need values this includes fields like text, search, hidden fields.
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Validation: Input is not a checkbox nor a number input, so defaulting to x number of fields need values");
            }
            inputs = $("[" + expressSelectors()['forms']['group-id'] + "=" + groupId + "]");

            // If an input has a value.
            let hasValue = 0;
            // How many inputs are we dealing with?
            let count = inputs.length;
            // Loop through files
            while (count >= 1) {
                // Deincrementing now not at the end of the function as length is not 0 based and we're using the count to identify the an input index in the inputs array.
                count--;
                // Get the input in question.
                let input = $(inputs[count]);
                // Get the intput's value.
                let inputValue = input.val();
                // Does the input has a value?
                hasValue = (inputValue.length > 0 ? hasValue + 1 : hasValue);
            }
            if (hasValue < min) {
                isValid = false;
            }
        }
        // Remove any error classes if valid.
        if (isValid && inputs.hasClass('is-invalid-input')) {
            form.foundation('removeErrorClasses', inputs);
        }
    } else {
        AXISDebug.output(2,"Validation: validator min-required only supports inputs at the moment.");
    }

    if (!isValid && $element.attr(expressSelectors()['forms']['group-id'])) {
        displayGroupValidation = true;
    }

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, `Min required validation:
        Input Name: ${$element.attr('name')}
        Is the value valid: ${isValid}
    `);
    }

    // If live validation validate call + suppress live validation force to return true.
    if ((liveValidation && suppressLiveValidation) && !isValid) {
        return true;
    }
 
    return isValid;
}
// Get the validators being used for a particular input ( i.e vm-validate, max-allowed ).
function getValidators(context) {
    // Get validator(s)
    let validators = context.attr('data-validator');
    if (validators) {
        // Convert string to an array.
        let array = validators.split(' ');
        return array;
    } else {
        return false;
    }
    
}
/** 
    context = the input you're validating against.
    valid = whether the input is valid or not normally the output from vmValidation
    fieldError = for live validation to prevent error(s) from being presented before submission but allows for them to disappear if corrected via live validation.
    revalidating = primarily used for the file input to prevent to file output function from triggering due to having to revalidate after dom manipulation due to selections overwriting previously selected files ( going against standard browser functionality ). 
**/
function validationOutput2(context, valid, fieldError = true, revalidating = false) {
    // form context.
    let form = context.parents('form');
    // Get group id.
    let groupId = context.attr(expressSelectors()['forms']['group-id']);
    // Fallback for group id.
    if (!groupId) {
        groupId = context.attr(expressSelectors()['forms']['input-group-id']);
    }
    // Get parent context, this could be an input or on a form.
    let groupParentContext = undefined;
    // Context is parent.
    if (context.attr(expressSelectors()['forms']['input-group-id'])) {
        groupParentContext = context;
    } else {
        // Find it as it maybe a form input.
        groupParentContext = $('[' + expressSelectors()['forms']['input-group-id'] + "=" + groupId + ']');
        if (!groupParentContext) {
            console.warn("Could not find group parent context");
        }
    }
    // Check whether this is a input inside of a group.
    let isGroupedInput = (context.attr(expressSelectors()['forms']['group-id']) != undefined);

    // Does this input have a slider assigned.
    let sliderId = context.attr('slider-input');
    // Context Id.
    let id = context.attr('id');
    if (!id && AXISDebug.level() >= 2) {
        AXISDebug.output(2,"Validation: This input doesn't have an Id so if external form errors will not be supported", context);
    }
    // Input type.
    let type = context.attr('type');
    // Find label.
    let label = context.parents('label');
    switch(valid) {
        case null: 
            // This state essentially sets the input back to it default state so for example look ups fields typically only are required when their value > 0.
            // Remove any validation classes.
            context.removeClass('is-valid-input');
            // Remove error classes from input.
            form.foundation('removeErrorClasses', context);

            // If this input has a button next to it in the DOM then disabled it due to no value.
            if (context.next().is('button[type=button]')) {
                context.next().addClass('disabled');
            }
            break;
        case false:
            // Specifically for the checkout.
            form.removeAttr('form-is-submitting', '');
            // INVALID INPUT!!! :(
            if (context.hasClass('is-valid-input')) {
                context.removeClass('is-valid-input');
            }
            // If label is within the control framework.
            if (label.hasClass('control')) {
                if (!label.hasClass('is-invalid-label')) {
                    label.addClass('is-invalid-label');
                }
            }
            // Don't disable as it this will prevent the validation from triggering again.
            // If this input has a button next to it ( ie a lookup button )
            // if (context.next().is('button[type=button]') && context.attr('type') != "password") {
                // if (AXISDebug.level() >= 3) {
                //     AXISDebug.output(1,"Live validation: this input has an action button next to it therefore disabling.");
                // }
               // context.next().addClass('disabled');
            // }
            if (context.attr('type') == "file") {
                if (isAbideEnabled(context)) {
                    context.parents('form').foundation('addErrorClasses', context, ['vm-validate']);
                }  
            }
            if (isAbideEnabled(context)) {
                // Does this input belong to a group?

                if (isGroupedInput) {
                    // Apply error states to group inputs.
                    context.parents('form').foundation('addErrorClasses', $('[' + expressSelectors()['forms']['group-id'] + "=" + groupId + "]"));
                    // If not parent input then force a revalidate.
                    if (!context.attr(expressSelectors()['forms']['input-group-id'])) {
                        // Make sure this is actually a input before running validation.
                        if (groupParentContext.is('input')) {
                            form.foundation('validateInput', $('[' + expressSelectors()['forms']['input-group-id'] + '=' + groupId + ']'));
                        }
                    }
                } else {
                    if (fieldError || displayGroupValidation) {
                        // Foundation's addErrorClasses method doesn't support add error classes to form tags.
                        if (!context.is('form')) {
                            context.parents('form').foundation('addErrorClasses', context,  getValidators(context));
                            // Does this input have a slider assigned.
                            if (sliderId) {
                                // If it does have a slider attached then add invalid class.
                                $('[slider-id=' + sliderId + ']').addClass('slider-invalid');
                            }
                        }
                    }
                }

                displayGroupValidation = false;
            }
            if (groupId && fieldError) {
                // Check if has callout error?
                let calloutError = context.attr(expressSelectors()['forms']['validation']['callout-error']);
                // If there is a callout error then display it.
                if (calloutError) {
                    callouts.create(calloutError, 2, "side");
                }

                let onpageError = form.find('[' + expressSelectors()['forms']['group-error'] + '=' + groupId + ']');

                if (onpageError) {
                    onpageError.addClass('is-visible');
                }
            }
            
            // Check if there is a form error located somewhere in the DOM for this input.
            let externalError = $('[' + expressSelectors()['forms']['validation']['external-error'] + '="' + (groupId ? groupId : id) + '"]');
            if (externalError && fieldError) {
                // Check if this is a callout error?
                let calloutError = externalError.attr(expressSelectors()['forms']['validation']['callout-error']);
                
                if (calloutError != undefined) {
                    // Get the error message.*
                    calloutError = externalError.attr(expressSelectors()['forms']['validation']['callout-error']);
                    // Fallback
                    if (calloutError == "") {
                        // If not attribute value then check inside of element.
                        calloutError = externalError.html();
                    }
                    // If error message exists then create callout.
                    if (calloutError) {
                        callouts.create(calloutError, 2, "side");
                    }
                }

            }

            // If the input type is file then do file specific output.
            if (type == "file" && !revalidating) {
                fileUploadOutput(context, valid);
            }
            // disable form submission.
            context.parents('form').addClass('is-invalid');
            break;
        case true:
            // VALID INPUT! :)
            context.addClass('is-valid-input');
            // If wrapped in a container with invalid class then remove it.
            context.parents('div.is-invalid-container').removeClass('is-invalid-container');
            // If label is within scope of the control framework.
            if (label.hasClass('control')) {
                if (label.hasClass('is-invalid-label')) {
                    label.removeClass('is-invalid-label');
                }
            }
            // If the input had been previously invalid then remove error.
            // if (context.hasClass('is-invalid-input')) {
            //     context.parents('form').foundation('validateInput', context);
            // }
            if (isAbideEnabled(context)) {
                // Does this input belong to a group?
                if (isGroupedInput && !groupParentContext.is('form')) {
                    // Check if parent is invalid.
                    if (groupParentContext.is('.is-invalid, .is-invalid-input')) {
                        // If parent is invalid then add invalid state to input in context.
                        context.parents('form').foundation('addErrorClasses', context);
                        // If not parent input then force a revalidate.
                        if (!context.attr(expressSelectors()['forms']['input-group-id'])) {
                            // Make sure this is actually a input before running validation.
                            if (groupParentContext.is('input')) {
                                form.foundation('validateInput', $('[' + expressSelectors()['forms']['input-group-id'] + '=' + groupId + ']'));
                            }
                        }
                    }
                } else {
                    context.parents('form').foundation('removeErrorClasses', context);
                }

                // Does this input have a slider assigned.
                if (sliderId) {
                    // If it does have a slider attached then add invalid class.
                    $('[slider-id=' + sliderId + ']').removeClass('slider-invalid');
                }

                if (groupId) {
                    let onpageError = form.find('[' + expressSelectors()['forms']['group-error'] + '=' + groupId + ']');
    
                    if (onpageError) {
                        onpageError.removeClass('is-visible');
                    }
                }
            }
            // If this input has a button next to it ( ie a lookup button ) then enabled
            if (context.next().is('button[type=button]')) {
                context.next().removeClass('disabled');
            }
            // If the input type is file then do file specific output.
            if (type == "file" && !revalidating) {
                fileUploadOutput(context, valid);
            }
            // If there are other active errors then exit function.
            let activeErrors = context.parents('form').find('input.is-invalid-input');
            if (activeErrors.length) {
                return false;
            }
            // Does the form contain any outstanding inputs?
            let outstandingInputs = form.find('input[data-validate]:not(.is-valid-input), select');
            // Enable submit button flag.
            let enableSubmitButton = true;
            // Loop over outstanding inputs, if any invalid ones are found then do no enable button.
            outstandingInputs.each(function() {
                // Input context.
                let outstandingInput = $(this);
                // Check if we need to valid input.
                if (outstandingInput.attr('data-abide-ignore') != undefined) {
                    return true;
                }
                enableSubmitButton = vmValidation(outstandingInput);
                // If an invalid input is detected then break out of loop.
                if (!enableSubmitButton) {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(2,"Validation Form has an outstanding input that is not valid", outstandingInput);
                    }
                    return false;
                }
            });
            if (enableSubmitButton) {
                // Check if form submit button is disabled ( going on the assumption that it will always be the last submit button).
                let submitButton = context.parents('form').find('button[type="submit"]').last();
                // If submit button disabled at this point the form should be valid so its safe to remove that attrbute.
                // Adding check against attribute is-submitting specifically for the checkout to prevent multiple submissions as it doesn't follow our generic ajax logic....
                if (submitButton.length) {
                    if ((submitButton.attr('disabled') || submitButton.hasClass('disabled')) && (form.attr('form-is-submitting') == undefined)) {
                        submitButton.removeAttr('disabled');
                        submitButton.removeClass('disabled');
                    }
                }
            }
            // Re-enable the form.
            context.parents('form').removeClass('is-invalid');
           
            break;
        default:
            AXISDebug.output(3,"Validation: Could not output validation state are none was passed into output function");
            return false;
    }
    return true;
}

function fileUploadOutput(context, valid) {
    // Get file control instance id.
    let id = getFileInstance(context);
    // Container Id.
    let container = getFileContainer(id);
    // Label
    let label = getFileLabelContext(id);
    // Get File uploaded text.
    let fileUploadedText = getFileUploadText(id);
    // For if the input is invalid get the error text.
    let errorText = getFileErrorText(id);
    // Hold file names
    let filesText = "";
    // Get previously assigned files.
    let previousFiles = getFileFiles(id);
    // We're going to use the data transfer api to build a new files object.
    let dataTransfer = new DataTransfer();
    // Get the file list from the input.
    let fileList = context.prop('files');
    // Check whether multiple files are permitted.
    let isMultiple = (context.attr('multiple') != undefined);
    if (isMultiple) {
        $.each(fileList, function(i, file) {
            // Add file to object.
            dataTransfer.items.add(file);
            // Check if file has been previously added.
            if (previousFiles) {
                // Set match found flag.
                let matchFound = false;
                // How many files are previosily selected?
                let count = previousFiles.items.length;
                // Loop through files
                while (!matchFound && count >= 1) {
                    // Do the check.
                    if (dataTransfer.files[i]['name'] == previousFiles.files[count - 1]['name']) {
                        matchFound = true;
                    }
                    count--;
                }
                // If match not found then this is a new file!
                if (!matchFound) {
                    previousFiles.items.add(file);
                }
                // Update instance.
                setFileFiles(id, previousFiles);
                // Update input.
                context.prop('files',  getFileFiles(id).files)
            } else {
                // Then this is the first selection.
                setFileFiles(id, dataTransfer);
            }
        });
        // Re-validate after DOM has be manipulated.
        valid = AXISInputs.validateInput(context);
        // Correctly assign error classes.
        validationOutput2(context, valid, false, true);
    }
    

    // File instances.
    let files = [];
    for (let [key, value] of Object.entries(context[0].files)) {
        // File context.
        let file = value;
        // File name.
        let name = file['name'];
        filesText = name;  
        // File size
        let size = file['size'];
        // Create file config that matches file instance with id.
        let config = {};
        // Generate id.
        config['id'] = generateId()
        config['name'] = name;
        config['size'] = size;
        // Push config for files instance.
        files.push(config);
    }
    // Update label.
    if (valid) {
        // Get ready to upload text.
        if (fileUploadedText) {
            label.text(fileUploadedText);
        }
    } else {
        // Update label with error.
        label.html(errorText);
    }
    
    // Input button container.
    let buttonContainer = BuildButtonContainer();
    // If the input doesn't already have a button container then make one.
    if (container.find('.input-button-container').length == 0) {
        $(buttonContainer).insertAfter(label);
    }
    // Remove button html.
    let removeButton = "<button type='button' class='remove-button' data-remove-file title='" + getFileRemoveText(id) + "'>" + filesText + "</button>";


    let buttons = "";
    $.each(files, function(key, config) {
        // Build button mar kup.
        let button = `<button type="button" class="remove-button" data-remove-file="${config['id']}" title="${getFileRemoveText(id)}">${config['name']} <span class="file-size">${formatFileSize(config['size'])}</span></button>`;
        // Add button to string.
        buttons = buttons + button;
    });
    // Update DOM.
    // label.append(removeButton);
    //container.find('.input-button-container').html(removeButton);
    container.find('.input-button-container').html(buttons);
    // Update remove button context.
    removeButton = container.find('[' + expressSelectors()['forms']['controls']['file-remove'] + ']');
    // Update container class.
    if (valid) {
        container.addClass('is-ready');
    } else {
        container.removeClass('is-ready');
    }

    // File remove click listener.
    removeButton.on('click', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Context.
        let button = $(this);
        // Get file Id.
        let fileId = button.attr(expressSelectors()['forms']['controls']['file-remove']);
        // Which file are we going to delete in the list?
        let deletedIndex = 0;
        // We're going to use the data transfer api to build a new files object.
        let deletedFiles = new DataTransfer();
        // Get the file list from the input.
        let fileList = context.prop('files');
        // Loop through adding files that do not match the file begin deleted to new object.
        $.each(files, function(key, config) {
            if (config['id'] != fileId) {
                deletedFiles.items.add(fileList[key]);
            } else if (config['id'] == fileId) {
                deletedIndex = key;
            }
        });
        files.splice(deletedIndex, 1);
        // Update input with new object.
        context.prop('files', deletedFiles.files);
        // Update instance.
        setFileFiles(id, deletedFiles);
        // Remove listener.
        button.off('click');
        // Trigger input change.
        context.trigger('change');
        // Remove button.
        button.remove();
        if (!files.length) { 
            // Get default text.
            let defaultText = getFileDefaultText(id);
            // Reset label Text.
            label.html(defaultText);
            // Remove is-ready class from context.
            container.removeClass('is-ready');
        }
    });
} 

// The core logic behind the general purpose validator that gets used pretty much every where in express, this does NOT handle outputting the error if the validation is false.
function vmValidation($element, required, parent) {
    // If required is undefined first double check if the attribute is on the input.
    if ($element.attr('required') && required == undefined) {
        required = true;
    } else if (required == undefined && $element.attr('required') == undefined) {
        required = false;
    }
    // If this input type should be ignored then exit.
    let inputType = $element.attr('type');
    if ($.inArray(inputType, ignoredInputs) > -1) {
        AXISDebug.output(1,"Axis Inputs: skipping validation as this input " + $element.attr('name') + " as it an ignored input, here is a list of ignored inputs: ", ignoredInputs);
        return true;
    }

    // If this input's condition has not be met then exit.
    let depends = true;
    if ($element.attr(expressSelectors()['forms']['depends'])) {
        // Check.
        depends = conditionalValidation($element);
    }
    if (!depends) {
        return false;
    }
    // Form context.
    let form = $element.parents('form');
    // If this input is not inside of a form for whatever reason ( inputs temporarily moved out of form for modal ) then exit the function.
    if (form == undefined) {
        return false;
    }
    // Regex pattern.
    let pattern = new RegExp($element.data('validate'));
    // Get the input id.
    let inputId = $element.attr('name');
    // Get the input value.
    let inputValue = $element.val();
    // Make sure the input value is a string.
    inputValue.toString();
    // Whether or not the input's value passed regex checks, the value is valid == true unless proven otherwise.
    let isValid = true;
    // If the type is file then take a different path to just checking the value against the regexp.
    if (inputType == "file") {
        // Check if we're restricting the files types.
        let accept = $element.attr(expressSelectors()['forms']['validation']['file-accept']);
        // Check the file size limit.
        let sizeLimit = $element.attr(expressSelectors()['forms']['validation']['file-size']);
        // If limit then parse.
        sizeLimit = (sizeLimit ? parseInt(sizeLimit) : undefined);
        // Get the file(s).
        let files = $element[0].files 
        // Size limit defined then check that.
        if (sizeLimit) {
            for (let [key, value] of Object.entries(files)) {
                if (!isValid) {
                    return false;
                }
                // File context.
                let file = value;
                // File size.
                let size = file['size'];
                // Convert size to MB.
                let sizeInMB = byteToMB(size);
                if (sizeInMB <= sizeLimit) {
                    isValid = true;
                } else {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1,"Axis inputs: Validation failed due to file size " + sizeInMB + " exceeding limit" + sizeLimit + "");
                    }
                    isValid = false;
                }
            }
        }

        if (accept) {
            // Put accepted files into an array.
            let acceptedFiles = accept.split(",");       
            for (let [key, value] of Object.entries(files)) {
                // Get the accepted files count.
                let acceptedCount = acceptedFiles.length; 
                // File context.
                let file = value;
                // File name.
                let name = file.name
                let matchFound = false;
                // For each file type check if the file inputed is allowed.
                acceptedFiles.forEach(function(value) {
                    if ((!matchFound && acceptedCount != 0) && isValid) {
                        // De-increments accepted count.
                        acceptedCount--;
                        // Create regexp.
                        let regex = new RegExp(".*\\" + value + "$", 'i');
                        // Run test.
                        matchFound = regex.test(name);
                        // Update valid flag.
                        if (!matchFound && acceptedCount == 0) {
                            isValid = matchFound;
                        }
                    }
                });
            }
        }
    } else {
        // If no pattern then try and fallback to default attributes ( min, max ).
        if (pattern.source && inputType != "number") {
            // Test the input value against the regexp.
            isValid = pattern.test(inputValue);
        } else {
            if ($element.attr('max')) {
                // Get max value.
                let max = parseInt($element.attr('max'));
                // Is the input value bellow the max value?
                isValid = (parseInt(inputValue) <= max);
            }
            if ($element.attr('min') && isValid) {
                // Get min value.
                let min = parseInt($element.attr('min'));
                // Fallback
                if (!min) {
                    min = 0;
                }
                isValid = (parseInt(inputValue) >= min);
            }
            if ($element.attr('step') && isValid) {
                // Get step value.
                let step = parseInt($element.attr('step'));
                // If the input value is not a multiple of the step then mark as invalid.
                isValid = multipleOf(inputValue, step);
            }
        }
    }
    // If advanced validation module exists.
    if ($('.advanced-validation').length) {
        // Is it for this input?
        if ($('.advanced-validation').data('validate-input') == inputId) {

            $('#' + inputId).parents('label').addClass('advanced-validation-active');

            $('.advanced-validation li[data-validate]').each(function() {
                // Advanced rule pattern.
                let advancedPattern = new RegExp($(this).data('validate'));
                // Tests the pattern against the input value.
                let advancedIsValid = advancedPattern.test(inputValue);
                // Toggle classes depending on the outcome.
                if (advancedIsValid) {
                    $(this).addClass('is-valid');
                    $(this).removeClass('is-invalid');
                } else {
                    $(this).removeClass('is-valid');
                    $(this).addClass('is-invalid');
                }
                //console.log(">>>> " + advancedIsValid + " ||" + inputValue)
            });
        }
    }

    // Callback button validation, the input cannot have 0 value.
    let buttonValidate = $('[data-button-validate="' + inputId + '"]');
    if (buttonValidate.length > 0) {
        // if (inputValue.length == 0) {
            // if (AXISDebug.level() >= 3) {
            //     AXISDebug.output(1, "Live validation: Failed due to value = 0");
            // }
            //isValid = false;
        // } 
    } else if (inputValue.length == 0 && !required) {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Validating: Input is not required and it doesn't have a value so therefore defaulting valid status to true");
        }
        // Setting to true because the input is not required, null is not a valid response either as it will fire the invalid.zf.abide event which will incorrectly output the error state.
        isValid = true;
    }

    // One last check for select dropdowns as they typically don't have a data-validate set.
    if ($element.is('select') && required) {
        if (!inputValue.length) {
            isValid = false;
        }
    }

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, `Validating:
        Input Type: ${inputType}
        Input Name: ${$element.attr('name')}
        Input Value: ${(inputType != 'password' ? inputValue : '[ --- ]')}
        Validator Pattern: ${pattern}
        Form: ${form.attr('id')}
        Is the value required: ${required}
        Is the value valid: ${isValid}
        Element context: ${$element[0].outerHTML}
    `);
    }

    // Return result.
    return isValid;
};

// Check condition is met and that the parent element value is valid.
function conditionalValidation(element) {
    if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Validate: This value has a conditional input checking whether condition has been met.");
    }
    const checkConditional = isConditionMet(element);
    if (checkConditional['success']) {
        const conditionalInput = checkConditional['data']['conditional-element'];
        const conditionMet = checkConditional['data']['condition-met'];
        // Finally check if the conditional value is valid.
        // DON'T do this it will result in a infinite loop.
        //$(element.parents('form')).foundation('validateInput', conditionalInput);
        // Return status.
        return conditionMet;
    } else {
        console.error("Validate: Conditional validation failed.", checkConditional['data']['reason']);
    }
    
}

// Check if conditional element ( parent element ) is met, this is primarily engineered for inputs that are behind a checkbox ( e.g. optional delivery fields ).
function isConditionMet(childInput) {
    let conditionalInput = childInput.attr(expressSelectors()['forms']['depends']);
    if (!conditionalInput) {
        AXISDebug.output(3,"Validate: Conditional inputs please provide a input name or id", childInput);
        return {
            success: false,
            data: {
                reason: "No valid id or name provided"
            }
        };
    }
    // Find input in DOM, check for the presences of the ID.
    let parentElement = $('#' + conditionalInput);
    // Fallback to using the name.
    if (!parentElement.length) {
        parentElement = $('[name=' + conditionalInput + ']');
    }
    if (!parentElement || !parentElement.length) {
        AXISDebug.output(3,"Validate: Could not find data-depends element in the DOM, exiting function");
        return {
            success: false,
            "data": {
                reason: "Could no find parent element in DOM"
            }
        };
    }
    // Get Value.
    const value = (getInputValue(parentElement) > 0);
    return {
        success: true,
        data: {
            "conditional-element": parentElement,
            "condition-met": value
        }
    };
}

// Cannot use the abide attribute " data-live-validate " as we only want one input to validate on keyup, so have had to make this function which adds the listener to the relievent input.
function advancedValidation(context) {
    let input = context.data('validate-input');
    if (!input) {
        AXISDebug.output(3,"Advanced Validation: Could not find input.");
        return false;
    }
    $('body').on('keyup focusout', '#' + input, function(event) {
        // To prevent validation from being run if tabbed onto the input field.
        if (event.key != "Tab") {
            input = $(this);
            input.parents('form').foundation('validateInput', input);
        }
    });
}

$('form[data-abide] input, form[data-abide] select, form[data-abide]').each(function() {
    let context = $(this);
    // General purpose validation provided by vm.
    let initCustomValidators = initaliseCustomValidators(context)
});

//----- Initialise custom validators -----

// VM Validator validates form fields using Regular expressions set by vMerchant.
function initaliseCustomValidators(context) {
    let activeValidators = context.data('validator');

    // If there are no active validators then provide empty string.
    if (!activeValidators) {
        activeValidators = "";
    }
    // Checked if VM has given us a regex validation string.
    // if (context.data('validate') || context.attr('type') == 'file') {   
    // Modifying this to always output vm-validate validator so we still run through the basic validation even when no regex is provided which will result in falling back to basic input attributes such as min, max, step & required      
    if (context.attr('data-validate') != undefined) {
        activeValidators = activeValidators + " vm-validate ";    
    } 
    
    // }

    // If there are active validators then update attribute.
    if (activeValidators) {
        context.attr('data-validator', activeValidators.trim());
        return true;
    } else {
        return false;
    }
}

function controlInitialiseAll() {
    $('.control').each(function() {
        // Store context.
        let context = $(this);
        // Initialise input.
        control(context);
    });
}

// Attempt to assign appropriate class.
function control(context) {

    // Get input.
    let input = context.find('input');
     // If no input then fallback to select.
     if (!input || input.length == 0) {
        input = context.find('select');
        // If select cannotbe found then you must be a text area.
        if (input.length == 0) {
            input = context.find('textarea');
        }
    }
    // If fallback fails then exit.
    if (!input || input.length == 0)  {
        AXISDebug.output(3,"Inputs: Could not find input.");
        return false;
    }

    if (context.hasClass('undefined')) {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Inputs: Attempting to assign class to " + input.attr('name') + ".");
        }
        // Determine whether this is a checkbox, radio, text field or select.
        if (!input.is('select') && input.is('input')) {
            let inputType = input.attr('type');
            if (inputType == "checkbox") {
                input.parents('label').addClass('checkbox');
            } else if (inputType == "radio") {
                input.parents('label').addClass('radio');
            } else if (inputType == "search") {
                input.parents('label').addClass('search');
            } else {
                input.parents('label').addClass('text');
            }
            input.parents('label').removeClass('undefined');
        } else if (input.is('select')) {
            // Assign class to label.
            input.parents('label').addClass('select');
            input.parents('label').removeClass('undefined');
        } else if (input.is('textarea')) {
            input.parents('label').addClass('textarea');
            input.parents('label').removeClass('undefined');
        }
    }
    // Should this control be focused?
    if (input.attr(expressSelectors()['forms']['controls']['focus']) != undefined) {
        focusElement(input);
    }
    if (context.hasClass('select')) {
        controlSelectInitialise(context);
    } else if (context.hasClass('checkbox')) {
        controlCheckbox(context);
    } else if (context.hasClass('file')) {
        controlFile(context);
    } else if (context.hasClass('search')) {
        controlSearch(context);
    } else {
        controlInput(context);
    }
    
}


function controlSearch(context) {
    // Find input.
    let input = context.find('input[type="search"]');
    if (!input) {
        AXISDebug.output(3,"Axis Inputs: Could not find input");
        return false;
    }
    // Get parent form.
    let form = context.parents('form');
    // Handling clear functionality.
    input.on('search', function() {
        // Is this a lookup?
        let isLookup = (input.attr(expressSelectors()['lookups']['lookup-key']) != undefined);
        // Get input value.
        let inputValue = input.attr('value');
        // Fallback.
        if (!inputValue) {
            inputValue = input.prop('value');
            if (!inputValue) {
                AXISDebug.output(3,"Axis Inputs: Could not find input value.", input);
                return false;
            }
        }
        // Make sure value attribute == property.
        let propertyValue = input.prop('value');
        // The attribute value normally only gets set by the server which in this case we need to trigger a callback to reset the content container. 
        if (inputValue.length) {
            // Make sure values match.
            input.val(propertyValue);
            // Depending on which system this element is using to communicate with the server the process maybe different ( i.e are we post an entire form or just part of it ).
            if (isLookup) {
                // Find lookup instance in DOM.
                let lookup = $('[data-ajax-include="' + input.attr('id') + '"]');
                // Trigger a lookup.
                lookup.trigger('click');
            } else if (form.length) {
                //form.trigger('submit');
            }     
        }
    });
}



//----- Handles all inputs hover states, active states & validation ----- 
var controlFileInstances = {};

function setFileInstance(context) {

    // Make sure the context is the input not the label.
    if (!context.is('input[type=file]')) {
        context = context.find('input[type=file]');
    }

    if (context == undefined) {
        AXISDebug.output(3,"Controls: Could not find file input");
        return false;
    }

    let id = context.attr(expressSelectors()['forms']['controls']['file-instance']);
    // If this tooltip has not been initialise then create new instance.
    if (!id) {
        id = generateId();
        // Assign id.
        context.attr(expressSelectors()['forms']['controls']['file-instance'], id);
        // Create a new instance.
        controlFileInstances[id] = {};
    }
    return id;
}

function getFileInstance(context) {
    return context.attr(expressSelectors()['forms']['controls']['file-instance']);
}

function setFileLabelContext(id, value) {
    controlFileInstances[id]['label-context'] = value;
    return controlFileInstances[id]['label-context'];
}

function getFileLabelContext(id) {
    return controlFileInstances[id]['label-context'];
}

function setFileContext(id, value) {
    controlFileInstances[id]['context'] = value;
    return controlFileInstances[id]['context'];
} 

function getFileContext(id) {
    return controlFileInstances[id]['context'];
}

function setFileContainer(id, value) {
    controlFileInstances[id]['container'] = value;
    return controlFileInstances[id]['container'];
}

function getFileContainer(id) {
    return controlFileInstances[id]['container'];
}

function setFileDefaultText(id, value) {
    controlFileInstances[id]['default-text'] = value;
    return controlFileInstances[id]['default-text'];
}

function getFileDefaultText(id) {
    return controlFileInstances[id]['default-text'];
}

function setFileUploadText(id, value) {
    controlFileInstances[id]['upload-text'] = value;
    return controlFileInstances[id]['upload-text'];
}

function getFileUploadText(id)  {
    return controlFileInstances[id]['upload-text'];
}

function setFileErrorText(id, value) {
    controlFileInstances[id]['error-text'] = value;
    return controlFileInstances[id]['error-text'];
}

function getFileErrorText(id) {
    return controlFileInstances[id]['error-text'];
}

function setFileRemoveText(id, value) {
    controlFileInstances[id]['remove-text'] = value;
    return controlFileInstances[id]['remove-text'];
}

function getFileRemoveText(id) {
    return controlFileInstances[id]['remove-text'];
}

function setFileFiles(id, value) {
    return controlFileInstances[id]['files'] = value;
}
   
function getFileFiles(id) {
    return controlFileInstances[id]['files']
}


function controlFile(context) {
    // Get instance id or create one.
    let id = setFileInstance(context);
    // Get input 
    let input = context.find('input[type=file]');
    // The label for the input.
    let label = context.find('.label');
    // Store default label.
    let defaultText = label.text();
    // Remove label.
    let removeText = input.attr(expressSelectors()['forms']['controls']['file-remove-text']);
    // Remove fallback.
    if (removeText == undefined) {
        removeText = "Remove File";
    }
    // Ready to upload text.
    let uploadText = input.attr(expressSelectors()['forms']['controls']['file-upload-text']);
    // Error text.
    let errorText = input.attr(expressSelectors()['forms']['controls']['file-invalid-text']);
    // Add fallback.
    if (errorText == undefined) {
        errorText = "Invalid file";
    }

    // Update instance with data from attributes.
    setFileLabelContext(id, label);
    setFileContext(id, input);
    setFileContainer(id, context);
    setFileDefaultText(id, defaultText);
    setFileUploadText(id, uploadText);
    setFileErrorText(id, errorText);
    setFileRemoveText(id, removeText);
}

// Builds the markup specifically for the input buttons ( ie inputs that have their own custom controls )
function BuildButtonContainer() {
    let markup = "<span class='input-button-container'></span>";
    return markup;
}

var controlSelectInstances = {};
function controlSelectInitialise(context) {

    // Get the select dropdown context.
    let dropdown = context.find('select');
    // Hide actual select.
    // TODO: This could probably be cleaned up a bit. 
    dropdown.css('width', 0);
    dropdown.css('height', 0);
    dropdown.css('margin', 0);
    dropdown.css('padding', 0);
    dropdown.css('border', 0);

    // Generate Id.
    let id

    if (!context.attr('control-select-id')) {
        id =  'select-' + dropdown.attr('name');
        // Assign id.
        context.attr('control-select-id',  id);
    } else {
        AXISDebug.output(1,"Control Selectors: Skipping initalisation as selector is already initialised.", context);
        return false;
    }

    // Cannot do display none as that then disables focus.
    //dropdown.css('display','none');
    
    // Get the selected index.
    let selected = dropdown.prop('selectedIndex');
    // Get select options.
    let options = [];

    dropdown.find('option').each(function() {
        let obj = {};
        // Store context.
        let item = $(this);
        // Get value.
        //let value = item.text();
        obj['value'] = item.text();
        // Get label.
        obj['label'] = item.attr('label');
        // Is option disabled?
        obj['disabled'] = (item.attr('disabled') ? true : false);
        // Take option classes?
        obj['classes'] = item.attr('class');
        // Add value to options array.
        options.push(obj);
    });

    // Create new instance
    controlSelectInstances[id] = {};
    // Add instance properties.
    controlSelectInstances[id]['selected-index'] = selected;
    controlSelectInstances[id]['options'] = options;
    controlSelectInstances[id]['dropdown'] = dropdown;
    // Build markup.
    // Create list.
    let list = "";
    $(options).each(function(key, value) {

        // Get any clasess that were applied to the original option.
        let classes = optionClasses(id, key);
        // Build option.
        list = list + `<li class="control-select-option ${(classes ? classes : "")}" data-option-index="${key}" ${(isOptionSelected(key, id) ? "selected" : "")} ${(isOptionDisabled(id, key) ? "disabled" : "")}>${optionLabel(id, key) ? optionLabel(id, key) : value['value']}</li>`
    });
    // Created selected markup.
    let selectedMarkup = `<div class="selected-option"><span class="selected-description">${options[selected]['value']}</span><span class="select-arrow"></span></div>`
    // Now build the complate dropdown markup.
    let markup = `
        <div class="control-select-container">
            <div class="control-select-dropdown">
                ${selectedMarkup}
                <ul class="control-select-options">
                    ${list}
                </ul>
            </div>
        </div>
    `
    // Output markup onto the page.
    dropdown.after(markup);
    // Get selected dom element.
    controlSelectInstances[id]['selected-option'] = context.find('.selected-option');
    // Listeners.
    context.on('click', function(event) {
        context = $(this);
        // If this dropdown is currently active then close it and exit function.
        if (context.hasClass('active')) {
            let close = selectClose(context);
            return false;
        }
        // Make sure any other lists are closed.
        $('.control.select').removeClass('active');
        // Remove listener.
        $(window).off('click');

        if (context.find('select').attr('disabled') || context.find('select').attr('readonly')) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "Control Select: You cannot use this select due to it either being disabled or readonly.")
            }
            let reason = invalidReason(context);

            return false;
        }

        // Get the list position.
        let listPosition = getListPosition(context);
        if (context.hasClass('dropdown-top')) {
            context.removeClass('dropdown-top');
        } else if (context.hasClass('drodown-bottom')) {
            context.removeClass('dropdown-bottom');
        }
        // Update list position.
        if (listPosition) {
            context.addClass(listPosition);
        }
        // Trigger list.
        context.toggleClass('active');
        // Scroll to selected.
        let scrollPosition = context.find('.control-select-options').scrollTop(context.find('.control-select-option[selected]').position().top - 45);      
        // Option listener.
        context.find('.control-select-option').on('click', function(event) {
            // Prevent bubbling.
            event.stopImmediatePropagation();
            // Store option context.
            let option = $(this);
            // Get select index.
            let selectIndex = option.data('option-index');
            // Get select text.
            let description = option.text();
            // Update select div.
            context.find('.selected-option .selected-description').html(description);
            let updateList = setSelectedIndex(selectIndex, id);
            // Remove listener as its no longer needed.
            option.off('click');
            // TODO: This will need to be made dynamic when multiple select get implemented.
            let close = selectClose(context);
            // Remove listener.
            $(window).off('click');
                
            return false;
        });

        //TODO: This should be configurable whether to auto close on mouse leave.

        // If anywhere in the window is clicked then close the list.
        $(window).on('click', function() {
            // Close list.
            let close = selectClose(context);
            // Remove listener.
            $(window).off('click');
        });
        return false;
    });
    dropdown.on('change', function() {
        // Find selected option.
        let selected = context.find('option:selected');
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Control Select: select has been changed here is the selected option: ", selected);
        }
        // Store label context.
        let container = context.closest('.field');
        // Workout if the selected option is for a custom input.
        // NOTE: We don't use the value being passed into the dropdown-custom-input attribute for 2 reasons A. Cannot offer backwards support as this was previously implemented using CSS classes, B. This is not required until we have to implement multi-select dropdowns with custom values, this was originally upgraded to use attributes as part of 839578.
        let isCustomOption = selected.attr(expressSelectors()['forms']['controls']['dropdown-custom-input']);
        // Fallback.
        if (!isCustomOption) {
            isCustomOption = selected.hasClass('custom-input');
        }
        // If the selected option is marked as a custom input then toggle the input.
        if (isCustomOption) {
            let customInput = toggleCustomInput(container);
        } else {
            // If a custom input was previously active and the currrently selected option is not a custom input then disable.
            if (container.find('.custom-input-container').length > 0) {
                if (!context.find('option:selected').hasClass('custom-input') && container.find('.custom-input-container, [' + expressSelectors()['forms']['controls']['dropdown-custom-input-container'] + ']').hasClass('active')) {
                    let customInput = toggleCustomInput(container);
                }
            }
        }
        // Remove listener as its no longer needed.
        context.off('change');
    });

    // Toggle custom input onload if active.
    // NOTE: There is not a fallback option for this using CSS classes, you need to use the data attributes for this feature.
    let dropdownCustomInput = dropdown.find('[' + expressSelectors()['forms']['controls']['dropdown-custom-input'] + ']');
    if (dropdownCustomInput.length) {
        // Is selected?
        let isCustomInputSelected = dropdownCustomInput.prop('selected');
        // If active then toggle custom input.
        if (isCustomInputSelected) {
            // Find field.
            let field = context.closest('.field');
            let customInput = toggleCustomInput(field);
        }
    }

    context.on('keydown', function(event) {
        // If enter key is pressed.
        if(event.which == 13) {
            // Trigger list.
            context.trigger('click');
        }
        let selected = getSelectedIndex(id);

        if (event.which == 40) {
            selected = context.find('[data-option-index=' + selected + ']');

            selected = selected.next('li').attr('data-option-index');

            selected = setSelectedIndex(selected, id);
            
            event.preventDefault();
        }
        if (event.which == 38) {
            selected = context.find('[data-option-index=' + selected + ']');

            selected = selected.prev('li').attr('data-option-index');

            selected = setSelectedIndex(selected, id);

            event.preventDefault();
        }  
    });

    // Bespoke event for when forms get reset.
    context.on('control-reset', function() {
        // Go in reverse, select from the <select> instead of the <ul>.
        selected = context.find('select').prop('selectedIndex');
        // Update DOM.
        selected = setSelectedIndex(0, id);
    });

    context.on('control-value-updated', function() {
        // Go in reverse, select from the <select> instead of the <ul>.
        selected = context.find('select').prop('selectedIndex');
        //console.log(selected);
        // Update DOM.
        selected = setSelectedIndex(selected, id);
        // Get select text.
        let description = context.find('option:selected').text();
        // Update select div.
        context.find('.selected-option .selected-description').html(description);
    });
}

function selectClose(context) {
    // Remove class active add class is-closing to keep the z-index=2 to prevent the other selects overlapping the closing animation.
    context.removeClass('active').addClass('is-closing');
    // Remove listener.
    $(window).off('click');
    context.on('transitionend', function(event) {
        // Prevent bubbling.
        event.stopImmediatePropagation();
        // once transition finished remove is-closing class so dropdown returns to original z-index.
        context.removeClass('is-closing');
        // Remove listener.
        context.off('transitionend');
    });
}

// This defines the rules on which the dropdown doesnt under the select box.
function getListPosition(context) {

    // TODO: this needs to be made dynamic.
    let height = 185;

    let listPosition = context.get(0).getBoundingClientRect();
        // Check if list can be displayed within viewport.
    if ((listPosition.bottom + height) >= (window.innerHeight || document.documentElement.clientHeight) ) {
        return "dropdown-top";
    } else if ((listPosition.top + height) >= (window.innerHeight || document.documentElement.clientHeight)) {
        return "dropdown-bottom";
    }

    if (context.parents('.carousel').length > 0) {
        return "dropdown-top";
    }
}

function setSelectedOption(id, value) {
    let context = controlSelectInstances[id]['selected-option'];
    // Find description.
    return context.find('.selected-description').html(value);
}

function getSelectedOption(id) {
    return controlSelectInstances[id]['selected-option'];
}

function setSelectedIndex(optionIndex, id, multiple = false) {
    if (optionIndex != undefined) {
        let select = $("[control-select-id='" +  id + "']")
        // First remove any other selected option unless you're a multi select.
        if (!multiple) {
            // Deselected the <li> fake select dropdown option.
            select.find('.control-select-option').removeAttr('selected');
            // Deselect the actual select dropdown option.
            select.find('select').find('option').removeAttr('selected');
        }
        // Add select attribute to <li> option.
        select.find('.control-select-option[data-option-index=' + optionIndex + ']').attr('selected', "");
        // Update select dropdown property.
        select.find('select').prop('selectedIndex', optionIndex);
        // Update select dropdown option attribute.
        select.find('select').find('option').eq(optionIndex).attr('selected', '');
        // Update instance.
        controlSelectInstances[id]['selected-index'] = optionIndex;
        // Update selected.
        setSelectedOption(id, controlSelectInstances[id]['options'][optionIndex]['value']);
        // Trigger the change so anything listening can be triggered.
        controlSelectInstances[id]['dropdown'].trigger('change');
        return controlSelectInstances[id]['selected-index'];
    } else {
        return false;
    }
    
    
}

function getSelectedIndex(id) {
    return controlSelectInstances[id]['selected-index'];
}

function isOptionSelected(optionIndex, id) {
    let selected = controlSelectInstances[id]['selected-index'];
    if (selected == optionIndex) {
        return true;
    } else {
        return false;
    }
}

function isOptionDisabled(id, optionIndex) {
    return controlSelectInstances[id]['options'][optionIndex]['disabled'];
}

function optionLabel(id, optionIndex) {
    return controlSelectInstances[id]['options'][optionIndex]['label'];
}

function optionClasses(id, optionIndex) {
    return controlSelectInstances[id]['options'][optionIndex]['classes'];
}

function controlCheckbox(context) {
    // Because inputs do not support readonly attribute.
    $('body').on('click', 'input[readonly]', function(event) {
        event.preventDefault();
        return false;
    })
    // Field container.
    const field = context.closest('.field');
    // Get input context.
    const input = context.find('> input[type="checkbox"]');
    // Check if this input has a custom input.
    const custom = context.next('.custom-input-container');
    if (input.length & custom.length > 0) {
        // The data-conditional-input is the prefered mechanism to use for this.
        input.on('change', function(event) {
            toggleCustomInput(field);
        });
    }
}

// Store previously active radios so if another in its group get clicked the click listener is removed from the previous button.
var previouslyActiveRadios = [];

function controlRadioButtons() {
    if ($('.control.radio').length > 0) {
        $('body').on('change', 'label.control.radio input:checked', function(event) {
            // Store button context.
            let context = $(this);
            // Get group id.
            let group = context.attr('name');
            // Check whether there are previously active buttons.
            if (previouslyActiveRadios.length != 0) {
                // If so are they in this group?
                $(previouslyActiveRadios).each(function(key, value) {
                    let item = value;
                    if (item.attr('name') == group) {
                        item.off('click');
                        if (AXISDebug.level() >= 3) {
                            AXISDebug.output(1,"Inputs: A previous radio button was active in this group, removing click listener");
                        }
                    }
                    // Was the previously selected button a trigger for a conditional group?
                    const isGroupTrigger  = value.attr(expressSelectors()['forms']['conditional-input']);
                    // Browsers don't fire an event when a radio button has changed from checked => unchecked but only unchecked => checked, which is a problem when we have a conditional group of inputs attached to a radio button ( i.e. custom input ) as you will not be able to untoggle.
                    if (isGroupTrigger) {
                        value.trigger('toggle-conditional-change');
                    }
                    previouslyActiveRadios.pop(value);
                });
            }
            previouslyActiveRadios.push(context);
        });
    }
}

// TODO: Group validation has now gotten big enough to be its own ES6 Module.
function groupedInputsInitialiseAll() {
    $('[' + expressSelectors()['forms']['input-group-id'] + ']').each(function() {
        // Get context.
        let context = $(this);
        // Initialise.
        let init = groupedInputsInitialise(context);
    })
}

// Interval for when to trigger group revalidation as multiple change events can be fired off in a short time span from components outside of this module.
var revalidationInternal = 0;

function groupedInputsInitialise(context) {
    // Get group id.
    let id = context.attr(expressSelectors()['forms']['input-group-id']);
    // Get max.
    let max = context.attr(expressSelectors()['forms']['group-max']);
    // Multiple.
    let multiple = context.attr(expressSelectors()['forms']['group-multiple']);
    // Get inputs.
    let inputs = context.find('[' + expressSelectors()['forms']['group-id'] + '=' + id + ']');
    // Is context a input? 
    let contextIsInput = false;
    if (context.is('input')) {
        contextIsInput = true;
    } else if (context.is('select')) {
        contextIsInput = true;
    } else if (context.is('textarea')) {
        contextIsInput = true;
    }
    // Get from context.
    const form = context.parents('form');
    // If context is an input then group inputs could be anywhere so adjusting scope.
    if (contextIsInput) {
        inputs = form.find('[' + expressSelectors()['forms']['group-id'] + '=' + id + ']');
    }
    // Does this group display number of items selected?
    let selectedCountContext = context.find('[' + expressSelectors()['forms']['selected-count'] + ']');
    // Does this group display the remaining number of items to select?
    let remainingContext = context.find('[' + expressSelectors()['forms']['remaining-count']+ ']');
    // Get remaining messages.
    let verboseMessaging = context.data('group-messaging');
    
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Inputs: Grouped inputs verbose messaging config:", verboseMessaging);
    }
    // Find out the type. 
    let type = inputs.attr('type');
    // Store the total for inputs.
    let total = calculateTotal();
    
    // Work out the remaining.
    let remaining = null;
    // Calculate the remaining count.
    calculateRemaining();
    // If initialising and no valiues have been selected and this is a multiple input then set the remaining to the multiple value.
    if (remaining == 0) {
        remaining = multiple;
    }
    // Update displays.
    updatedSelected();
    updateRemaining(getRemainingMessage());

    /* 
        Depending on the behavour " mode " a checkboxes behavour can be modified to do either of the following:
        - Bulk sets checked true/false on all inputs in a group.
        - If any of the child inputs are check then toggle parent.
        - Default to pick n mix style validation where you have min & max style validation which also outputs remaining selection required.
    */

    let mode = null;
    // Hardcoding attributes for now subject to discussion on naming 858919.
    if (context.attr(expressSelectors()['forms']['checkbox-parent-toggle']) != undefined) {
        mode = "checkbox-parent-toggle";
    } else if (context.attr(expressSelectors()['forms']['checkbox-toggle-all']) != undefined || context.attr('name') == "all-branches") {
        // Adding specific fallback as this previously had no attribute and was just assumed to be the default functionality, this will be inplace untill new data attribute is being used.
        mode = "checkbox-toggle-all"
    }

    // Mode specific onload procedure.
    if (mode == "checkbox-toggle-all") {
        // If all grouped inputs are already selected then check the parent.
        toggleAll(inputs, context);
    } else if (mode == "checkbox-parent-toggle") {
        // If parent not already toggled.
        if (!context.prop('checked')) {
            parentToggle(inputs, context);
        }
    }

    // On parent change.
    context.on('change group-parent-change', function() {
        // console.log("Group parent change detected", mode);
        switch (mode) {
           case "checkbox-toggle-all":
                // These additional checks can go once data-toggle-all attribute is being used 858919.
                if (context.is('input')) {
                    if (context.attr('type') == "checkbox") {
                        // Get checked status of parent.
                        let isChecked = context.prop('checked');
                        // Loop through each grouped input setting the value of the parent.
                        inputs.each(function() {
                            // Grab context.
                            let groupedInput = $(this);
                            // Get type.
                            let groupedInputType = groupedInput.attr('type');
                            // Set value.
                            if (groupedInputType == "checkbox") {
                                groupedInput.prop('checked', isChecked);
                            } else {
                                console.warn("Group inputs must be of type checkbox.");
                            }
                        });
                        toggleAll(inputs, context);
                         // Check if any parent checkboxes has parent toggle attribute.
                        const checkboxParentToggle = $('[' + expressSelectors()['forms']['input-group-id'] + '="' + id + '"][' + expressSelectors()['forms']['checkbox-parent-toggle'] + ']');
                        // If there is a parent toggle assigned then trigger that code to validate.
                        if (checkboxParentToggle.length && !isChecked) {
                            parentToggle(inputs, checkboxParentToggle);
                        }

                    } else {
                        console.warn("We only support checkbox inputs.");
                    }
                } else {
                    console.warn("We only support context being an input or form");
                }
                break;
           default:
                //console.log("No procedure for parent change for this mode", mode);
        }
    });

    // On child change.
    inputs.on('change group-child-change', function(event) {
        // Just incase we have modified any inputs via modal-inject.
        if (contextIsInput) {
            inputs = form.find('[' + expressSelectors()['forms']['group-id'] + '=' + id + ']');
        } else {
            inputs = context.find('[' + expressSelectors()['forms']['group-id'] + '=' + id + ']');
        }

        switch (mode) {
            case "checkbox-toggle-all":
                toggleAll(inputs, context);
                break;
            case "checkbox-parent-toggle":
                parentToggle(inputs, context);
                break;
            default:
                // Functionality primarily used by pick n mix / registration forms force users to select a set amount of checkboxes.
                // Calculate the remaining count.
                calculateRemaining();
                // Update displays.
                updatedSelected();
                updateRemaining(getRemainingMessage());
        }

    });


    function triggerGroupValidation(parent) {
        if (revalidationInternal) {
            clearInterval(revalidationInternal);
        }
        // Set internal as there could be multiple changes to a group at once.
        revalidationInternal = setInterval(() => {
            clearInterval(revalidationInternal);
            //validateForm(form);
            parent.trigger('revalidate-input');
        }, 500);
    }

    function calculateRemaining() {
        // Recalculate displays.
        total = calculateTotal();
        if (max) {
            remaining = inputsRemainingValue(max, total);
            // Essentially create overflow logic.
            if (remaining == 0 && total > max) {
                remaining = (total - max);
            }
        } else if (multiple) {
            remaining = (roundUp(total, multiple) - total)
        }
    }


    // Calculate total.
    function calculateTotal() {
        // Depending on the type do the calculation.
        switch(type) {
            case "number":
                return inputsTotalValue(inputs);
            default: 
                if (AXISDebug.level() >= 2) {
                    AXISDebug.output(2,"Inputs: Cannot calculate total for this type ", type);
                }
                return false;
        }
    }

    // Update the selected count display.
    function updatedSelected() {
        if (selectedCountContext) {
            // Update display.
            selectedCountContext.html(total);
        } 
    }
    // Update the remaining count display.
    function updateRemaining(message) {
        if (remaining) {
            // Update DOM with message.
            remainingContext.html(message);
            // Trigger message so user can see.
            remainingContext.addClass('active');
        } else {
            // Update DOM with message.
            remainingContext.html(message);
            // Hide message.
            remainingContext.removeClass('active');
        }
    }
    // Get custom message.
    function getRemainingMessage() {
        // If no custom messaging then exit.
        if (!verboseMessaging) {
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(2,"Inputs: No remaining messages defined.");
            }
            return false;
        }
        // Check whether total is a multiple.
        let isMultiple = multipleOf(total, multiple);
        if (total == 0) {
            return replaceCount(verboseMessaging['default']);
        } else if ((total < max) || total < multiple) {
            return replaceCount(verboseMessaging['less-than']);
        } else if ((total > max) || (total > multiple && !isMultiple)) {
            if (multiple) {
                // Output less than required messaging as you need to select in multiples of x.
                return replaceCount(verboseMessaging['less-than']);
            } else {
                return replaceCount(verboseMessaging['more-than']);
            }
        } else if ((remaining == total) || (!isMultiple)) {
            return replaceCount(verboseMessaging['less-than']);
        }
    }
    // Text replacement for the remaining to pick.
    function replaceCount(message) {
        return message.replace("{count}", "<span class='remaining-count'>" + remaining + "</span>");
    }
    // Total inputs.
    function totalInputs(inputs) {
        return inputs.length;
    } 
    // Total inputs checked.
    function totalInputsChecked(inputs) {
        let count = 0;
        inputs.each(function() {
            // Grab context.
            let input = $(this);
            // Increment count depending on checked status.
            if (input.prop('checked')) {
                count++;
            }
        });
        return count;
    }
    // If all child input are selected then check parent, if all unchecked then uncheck parent.
    function toggleAll(inputs, context) {
        if (inputs.length == 0) {
            AXISDebug.output(3,"Inputs: No grouped inputs found.");
            return false;
        }
        let button = context.attr(expressSelectors()['forms']['controls']['restricted-content']);
        // Get the context of the button.
        if (button) {
            button = $('#' + button);
        }
        // Get total inputs in group.
        let total = totalInputs(inputs);
        // Get total inputs in group selected.
        let totalSelected = totalInputsChecked(inputs);
        if (total == totalSelected) {
            if (!context.prop('checked') == true) {
                context.prop('checked', true);
            }
            // If there is an associated button then disable.
            if (button) {
                if (!button.hasClass('disabled')) {
                    button.addClass('disabled');
                }
            }
        } else {
            if (context.prop('checked') == true) {
                context.prop('checked', false);
            }
            // If there is an associated button then enable.
            if (button) {
                if (button.hasClass('disabled')) {
                    button.removeClass('disabled');
                }
            }
        }
        triggerGroupValidation(context);
    }

    // If all child inputs are unselected, deselect parent.
    function parentToggle(inputs, parent) {
        // Get total inputs in group selected.
        const totalSelected = totalInputsChecked(inputs);
        // Make sure parent is a checkbox.
        const isParentCheckbox = parent.is('input[type="checkbox"]');
        if (!isParentCheckbox) {
            console.error("Group validation: Parent must be a checkbox", parent);
            return false;
        }
        // Check to see if the parent is already checked.
        const parentChecked = parent.prop('checked');
        // Check for conditional container.
        const conditionalContainer = parent.attr(expressSelectors()['forms']['conditional-input']);
        // Flag for if parent state has changed.
        let changed = false;
        if (totalSelected == 0) {
            if (parentChecked) {
                parent.prop('checked', false);
                changed = true;
            }
        } else {
            if (!parentChecked) {
                parent.prop('checked', true);
                changed = true;
            }
        }
        if (changed) {
            // If the parent input is the toggle for conditional inputs then trigger that as well.
            if (conditionalContainer) {
                parent.trigger('toggle-conditional-change');
            }
        }
        triggerGroupValidation(parent);
        return changed;
    }
}

function restrictedContentInitialiseAll() {
    $('[' + expressSelectors()['forms']['controls']['restricted-content'] + ']').each(function() {
        // Grab context.
        let context = $(this);
        // Initialise.
        let init = restrictedContentInitialise(context);
    });
    // Fallback.... the old way of initialising.
    $('[' + expressSelectors()['forms']['controls']['restricted-content-text'] + ']:not([' + expressSelectors()['forms']['controls']['restricted-content'] + '])').each(function() {
        // Grab context.
        let context = $(this);
        AXISDebug.output(2,"Inputs: Using fallback for initialising restricted input, to be consistent you should really apply the " + expressSelectors()['forms']['controls']['restricted-content'] + " attribute.");
        AXISDebug.output(1, "", context);
        // Initialise.
        let init = restrictedContentInitialise(context);
    });
}

function restrictedContentInitialise(context) {
    // Store the id of the element that should be disabled.    
    let restrictedContentId = context.attr(expressSelectors()['forms']['controls']['restricted-content']);

    // If restricted content id is undefined then we take the assumption that the restricted content is context.
    if (!restrictedContentId) {
        context.on('click', function(event) {
            // Is disabled.
            let isDisabled = context.hasClass('disabled');
            if (isDisabled) {
                // Get callout content.
                let text = getRestrictedWarning(context);
                if (text) {
                    let callout = callouts.create(text, 2);
                } else {
                    if (AXISDebug.level() >= 2) {
                        AXISDebug.output(2,"Inputs: This input has been disabled but there is no warning text, you should really have text this is bad ui practice!");
                    }
                }
                // Prevent default behavour.
                event.preventDefault();
            }
        });
    }

    context.on('change', function() {
        // Update context.
        context = $(this);
        // Get input value.
        let value = getInputValue(context);
        // Get the restricted content context.
        let content = context.attr(expressSelectors()['forms']['controls']['restricted-content']);
        content = $('[id=' + content + ']')
        // Fallback.
        if (!content) {
            content = $('[name=' + content + ']')
        }
        // If its still not defined then exit.
        if (!content) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(3,"Inputs: No data-restricted-content attribute or content doesn't exist in dom");
            }
        }
        // Get restricted rule.
        let restrictedRule = context.data('restricted-rule');
        if (!restrictedRule) {
            AXISDebug.output(3,"Inputs: You must provide a data-restricted-rule to check against");
            return false;
        }
        // Check value against resticted rule
        if (value == restrictedRule) {
            content.addClass('disabled');
        } else if (content.hasClass('disabled')) {
            content.removeClass('disabled');
        }
    });
}

// Checks whether input is disabled / readonly then add disabled class to parent label;
function inputDisabled(context) {
    let label = context.parent('label');
    // Add specific class.
    if (context.attr('readonly') != undefined) {
        label.addClass('read-only-input');
    } else if (context.attr('disabled') != undefined) {
        label.addClass('disabled-input');
    } else if (!context.hasClass('disabled')) {
        // If not disabled then you shouldn't be here.
        return false;
    }
    // Get warning text.
    let warning = getRestrictedWarning(context);
    // If a warning is defined then add click listener.
    if (warning) {
        context.on('click', function(event) {
            let callout = callouts.create(warning, 2)
        });        
    } else if (AXISDebug.level() >= 3) {
        AXISDebug.output(2,"Notifications: No restricted-content-warning attribute found so no click event was added to this input.");
    }
}

function inputDisabledKill(context) {
    let label = context.parent('label');
    if (context.attr('readonly') != undefined) {
        label.removeClass('read-only-input');
    } else if (context.attr('disabled') != undefined) {
        label.removeClass('disabled-input');
    }
    context.off('click')
    return true;
}

function initialiseAllDisabledInputs() {
    $("input[disabled], input[readonly], select, button.disabled").each(function() {
        let context = $(this);
        let initialise = inputDisabled(context);
    });
    // As the readonly attribute doesn't do anything for checkboxes by default we're going to add in this functionality.
    $('body').on('click', 'input[type=checkbox][readonly]', function() {
        return false;
    });
}

function getRestrictedWarning(context) {
    // Get warning text.
    let text = context.attr(expressSelectors()['forms']['controls']['restricted-content-text']);
    // Fallback #1
    if (!text) {
        text = context.parents('table').attr(expressSelectors()['forms']['controls']['restricted-content-text']);
        // Fallback #2
        if (!text) {
            text = context.parents('[' + expressSelectors()['forms']['controls']['restricted-content-text'] + ']').attr(expressSelectors()['forms']['controls']['restricted-content-text']);
        }
    }

    return text;
}


//Input field classes.
function controlInput(initialiseELement = 'body') {
    if ($('input').length) {
        //On focus add active status to the form.
        $(initialiseELement).on('focus', 'input', function() {
            //Input context.
            var inputId = $(this);
            //Add active class to form.
            $(inputId).parents('form').addClass('active');
            //If the input has changed then prevent active class from being removed on focusout.
            $(inputId).on('change', () => {
                $(inputId).unbind('focusout');
            });
            //If no changes have been done then remove active state from form.
            $(inputId).focusout(function() {
                //If a value has been set then exit function.                
                if ($(inputId).val().length > 0) {
                    return false;
                }
                $(inputId).parents('form').removeClass('active');
            });
        });
    }
}

function initialiseAllPasswordReveals() {
    $('input[type=password]').each(function() {
        let context = $(this);

        let initialise = initialisePasswordReveal(context);

        if (!initialise) {
            AXISDebug.output(3,"Failed to initialise password reveal.");
        }
    });
}

function initialisePasswordReveal(context) {
    // Get the label container.
    let parentLabel = context.parents('label');
    // Trigger input styles.
    parentLabel.addClass('password-reveal-container')

    // Reveal password button markup.
    let revealMarkup = "<button type='button' class='password-reveal inline-button' tabindex='-1'></button>"
    // Output button.
    $(revealMarkup).insertAfter(context);

    if (parentLabel.find('.password-reveal')) {
        return true;
    } else {
        return false;
    }
}
$('body').on('mousedown touchstart', '.password-reveal', function() {
    // Capture button context.
    let context = $(this);
    // Get the label container.
    let parentLabel = context.parents('label');
    // Get input.
    let input = parentLabel.find('input[type=password]')
    // Reveal input value.
    if (input) {
        // Change input type to text.
        input.attr('type', 'text');
        // Add active class to reveal button.
        context.addClass('active');
        parentLabel.on('mouseleave mouseup touchend', function() {
            context.removeClass('active');
            input.attr('type', 'password');
            parentLabel.off('mouseleave mouseup');
        });

    } else {
        AXISDebug.output(3,"Could not find password input to reveal.");
    }
});


if ($('input[type=password]').length) {
    initialiseAllPasswordReveals();
}

// Holds all the input listeners ( things like live validation ).
function inputsListeners() {
    // Essentially live validation.
    // On input invalid.
    $(document).on("invalid.zf.abide", function(event, element) {
        // If a server error exists as -*these are only meant to be displayed once.
        if ($(event.target).parents('label').find('.form-error.server')) {
            $(event.target).parents('label').find('.form-error.server').remove();
        }
        // Get from context.
        let formId = $(event.target).parents('form').attr('id');
        // If there is no Id on the input raise an warning and exit.
        if (formId == undefined) {
            AXISDebug.output(2, "No Id defined on form: " + event.target.name);
            return false;
        }
        // If the input is invalid then add invalid class to the parent form.
        if (event.type == "invalid") {
            let output = validationOutput2($(event.target), false);
            //let output = validationOutput(formId, false);
            if (!output) {
                AXISDebug.output(2,"Failed to assign invalid class to a form");
            }
        }
    });
    // On input valid.
    $(document).on('valid.zf.abide', function(event, element) {
        // Get form context. 
        let formId = $(event.target).parents('form').attr('id');
        // If there is no Id on the input raise an warning and exit.
        if (formId == undefined) {
            AXISDebug.output(2, "No Id defined on form: " + event.target.name);
            return false;
        }
        // Ensure that the form is actually valid.
        if (event.type == "valid") {
            let output = validationOutput2($(event.target), true);
            //let output = validationOutput(formId, true);
            if (!output) {
                AXISDebug.output(2,"Failed to assign valid class to form: " + formId);
            }
        }
    });
    // If the abide invalid form event is fired then apply the invalid class.
    // On Form Invalid.
    $(document).on('forminvalid.zf.abide', function(event, element) {
        // Get form context. 
        let formId = event.target.id;
        // If there is no Id on the input raise an warning and exit.
        if (formId == undefined) {
            AXISDebug.output(2, "No Id defined on form: " + event.target.name);
            return false;
        }

        // Find the first invalid input.
        let firstError = $('#' + formId + ' .is-invalid-input').first();
        if (firstError.length) {
            // Check if first field is in view.
            if (!getViewPort(firstError)) {
                // Check if body has scroll lock.
                if (!$('body').hasClass('scrollLock')) {
                    console.warn(getHeaderSize());
                    // Scroll to error.
                    $('html, body').animate({
                        scrollTop: (firstError.offset().top - (getHeaderSize() + 25))
                    }, 200);
                }
                // Focus on error.
                firstError.trigger('focus');
            }
        }

        // Ensure that this is an invalid form.
        if (event.type == "forminvalid") {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Validation: " + formId + " is invalid.");
            }
            //let output = validationOutput2($(event.target), false);
            //let output = validationOutput(formId, false);
            // if (!output) {
            //      AXISDebug.output(2,"Failed to assign invalid class to a form");
            // }
        }

        
    });

    $(document).on('change keyup revalidate-input', '[data-abide] input, [data-abide] textarea, [data-abide] select', function(event) {
        // Store context.
        let context = $(this);
        // Get the event type.
        const eventType = event['type'];
        // Get the label.
        const labelContext = context.closest('label');
        // Form context.
        let form = context.parents('form');
        // Is abide enabled.
        // let isAbide = isAbideEnabled(form);
        // if (!isAbide) {
        //     return false;
        // }

        // let suppressLiveValidation = form.attr(expressSelectors()['forms']['suppress-live-validation']);
        // if (!suppressLiveValidation) {
        //     return false;
        // }

        // If modal or lookup then ignore as they handle their own validation.
        if (context.attr(expressSelectors()['modals']['input']) || context.attr(expressSelectors()['lookups']['lookup-key']) != undefined) {
            return false;
        }
        // Group id.
        let groupId = context.attr(expressSelectors()['forms']['group-id']);
        // Fallback to old conditional mechanism mechanism.
        if (!groupId) {
            // Check for old mechanism.
            groupId = context.attr(expressSelectors()['forms']['depends']);
            if (groupId) {
                // Check if condition is met.
                const checkConditional = conditionalValidation(context);
                if (!checkConditional) {
                    if (AXISDebug.level() >= 2) {
                        AXISDebug.output(2,"Validation: Skipping live validation due to " + expressSelectors()['forms']['depends'] + " not met.");
                    }
                    return false;
                }
            }
        }
        // Is valid? 
        let isValid = true;
        // Get validators.
        let validators = getValidators(context);

        if (validators && validators.includes('vm-validate')) {
            isValid = vmValidation(context);
        }
        if (validators && validators.includes('max-allowed') && isValid) {
            isValid = maxAllowed(context);
        }
        if (validators && validators.includes('min-required') && isValid) {
            isValid = minRequired(context, true, labelContext, eventType);
        }
        if (validators && validators.includes('multiple-of') && isValid) {
            isValid = multipleValidation(context);
        }

        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Validation: Running validation due to the following event \"" + event.type + "\" being fired on input", context);
            if (event.hasOwnProperty('originalEvent')) {
                if (event['originalEvent'].hasOwnProperty('key')) {
                    AXISDebug.output(1,"Validation: The following key was triggered: " + event['originalEvent']['key']);
                }
            }
            AXISDebug.output(1,"Validation: Here are the validator(s) being used ", validators);
        }
       
        // Suppress field error.
        let fieldError = true;
        if (event.type == "keyup") {
            fieldError = false;
        } else if (groupId) {
            fieldError = false;
        }

        // Output result.
        let output = validationOutput2(context, isValid, fieldError);
    });




    // If submit button is disabled & abide is not active.
    $(document).on('change', 'input[type=checkbox]', function() {
        // Store context.
        let context = $(this);
        // Store form context.
        let form = context.parents('form');
        // Submit button context.
        let submitButton = form.find('button[type=submit]');
        // If this form has no validation.
        let isAbide = (form.attr('data-abide') != undefined);
        // If abide is not active then remove disabled.
        if (!isAbide) {
            // If the submit button is disabled then re-enable it.
            if (submitButton.prop('disabled')) {
                submitButton.removeAttr('disabled');
            }
        }
    });
    $(document).on('keypress', 'a', function(event) {
        let context = $(this);
        // If space is hit then simulate left click.
        if (event.which == 32) {
            // Need to call the native DOM click not .trigger('click') as jQuery specifically excludes it on anchors.....
            context[0].click();
            // Prevent the page from being scrolled.
            event.preventDefault();
        }
    });
    $(document).on('click', '[data-input-prefix-icon]', function(event) {
        // Get context.
        let context = $(this);
        // Find input.
        let input = context.next('input, select, textarea');
        // If input found then focus it.
        if (input.length) {
            input.focus();
        }
    });
    $(document).on('click', '[data-button-validate]', function(event) {
        let context = $(this);

        let input = context.data('button-validate');

        // Find the input by id or name.
        if (input) {
            if ($('#' + input).length > 0) {
                // Check for input with id.
                input = $('#' + input);
            } else {
                // Fallback to looking for input using name.
                input = $('[name="' + input + '"]');
            }
        } else {
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(2,"Button validation: You must provide either an Id or name");
            }
            return false;
        }

        if (input != undefined) {
            let value = input.val();
            let isValid = false;
            // Get regex pattern
            let pattern = input.data('validate');
            if (pattern) {
                pattern = new RegExp(pattern);
                // Test input.
                isValid = pattern.test(value);
            }
            // Make sure the value is not empty i.e voucher code in the basket.
            if (isValid) {
                if (value != "") {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1,"Button validation: field is valid & has a value");
                    }
                    // Build object to assign to event.
                    let obj = {
                        'id': context.data('button-validate'),
                        'is-valid': true,
                        'context': context
                    };
                    // Fire event.
                    $(document).trigger('validation-button-isvalid', obj);
                    $(document).off('validation-button-isvalid');


                    if (context.parents('label').length > 0) {
                        context.parents('label').removeClass('is-invalid-label');
                    } else {
                        context.parent('div').removeClass('is-invalid-container');
                    }

                } else {
                    $(document).trigger('validation-button-invalid', context);

                    if (context.parents('label').length > 0) {
                        context.parents('label').addClass('is-invalid-label');
                    } else {
                        context.parent('div').addClass('is-invalid-container');
                    }
                    if (AXISDebug.level() >= 2) {
                        AXISDebug.output(1,"Button validation: field is empty exiting callback prep.");
                    }
                    return false;
                }
            }
            // Yeh dont do this .... it will break vouchers.
            //context.parents('form').submit();
        } else {
            AXISDebug.output(3,"Button validation: Couldn't find input to validate, please specify id, name or put the input above or bellow the button in the DOM.");
        }
        

    })
}

function toggleCustomInput(container) {
    // Find custom input container.
    let customContainer = container.find('[' + expressSelectors()['forms']['controls']['dropdown-custom-input-container'] + ']');
    // Fallback.
    if (!customContainer.length) {
        console.warn("Custom Inputs: Falling back to using CSS classes ideally you should be using the data attributes for this.", container);
        customContainer = container.find('.custom-input-container');
    }
    // If custom label exists ( essential other option )
    if (customContainer.length > 0) {
        // If input had been previously active then clear and form errors.
        if (customContainer.hasClass('active')) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "Custom Inputs: Input had previously been active clearing any form validation errors before de-activating.");
            }
            let form = customContainer.parents('form')
            // If this is an abide form then remove error classes.
            if (isAbideEnabled(form)) {
                form.foundation('removeErrorClasses', customContainer.find('input, select, textarea'));
            }
            // Tell abide to ignore the input due to it being hidden.
            customContainer.find('input, select, textarea').attr('data-abide-ignore','');
            // Disable the field so it doesn't get posted.
            customContainer.find('input, select, textarea').attr('disabled','');
            // Prevent the field from being tabbed onto.
            customContainer.find('input, select, textarea').attr('tabIndex','-1');
            customContainer.toggleClass('active');
            // Trigger change to update classes.
            customContainer.find('.control').trigger('change');
        } else {
            customContainer.toggleClass('active');
            // Allow abide to valid this input.
            customContainer.find('input, select, textarea').removeAttr('data-abide-ignore tabIndex disabled');
            // Trigger change to update classes.
            customContainer.find('.control').trigger('change');
        }
        return customContainer;
    } else {
        AXISDebug.output(2, "Custom Input: Could not find custom input", container);
        return false;
    }
}

// Re-initialising abide to validate the dynamic HTML.
function abideRestart(formContext) {
    // Destroy the existing instance.
    formContext.foundation('_destroy');
    // Initialise abide.
    let newInstance = abideStart(formContext);
    // Create new instance of abide.
    // let newInstance = new Foundation.Abide(formContext);
    if (newInstance.isEnabled) {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Validation: Successfully re-initialised abide.", newInstance);
        }
        return newInstance;
    } else {
        AXISDebug.output(3,"Validation: Failed to re-initialise abide.");
        return false;
    }
}

// Initialise abide validation on a form.
function abideStart(context) {
    AXISDebug.output(1,"Attempting to initialise abide form validation on form : " + context);

    if (!context.is('form')) {
        AXISDebug.output(2,"Validation: Attempting to initialise abide on a element that is not a form are you sure this is the correct element.", context);
    }

    $('#' + context.attr('id') + " :input").each(function() {
        let validate = initaliseCustomValidators($(this));
    });
    // Create new instance of abide.
    let newInstance = new Foundation.Abide(context);

    let errorBlock = $('#' + context.attr('id') + ' .error-block');

    // Check whether the error block is in view otherwise scroll into view.
    if (errorBlock.length > 0) {
        let errorInView = getViewPort(errorBlock);
        if (!errorInView) {
            Foundation.SmoothScroll.scrollToLoc(errorBlock, {threshold: 50,offset: getHeaderSize()});
        }
    }
    

    if (newInstance.isEnabled) {
        return newInstance;
    } else {
        AXISDebug.output(3,"Validation: Failed to initialise new abide instance.");
        return false;
    }
}

function isAbideEnabled(context) {
    if (context.is('form') && context.attr('data-abide') != undefined) {
        return true;
    } else if (context.parents('form') && context.parents('form').attr('data-abide') != undefined) {
        return true;
    } else {
        return false;
    }
}

function initialiseAllConditionalInputs() {
    // Initialise trigger
    $("[" + expressSelectors()['forms']['conditional-input'] + "]").each(function() {
        let context = $(this);
        let initialise = conditionalInputToggleInitialise(context);
    });
}

// Initialise conditional input toggle, this is primary used to show / reveal groups of inputs ( i.e delivery details ).
function conditionalInputToggleInitialise(context) {
    if (!context || context.length == 0) {
        AXISDebug.output(3,"Conditional Inputs: Failed to provide context exiting intialialisation.");
        return false;
    }
    // Put form into context.
    let form = context.parents('form');
    // Get instance id.
    let id = context.data('conditional-input');
    // Generate unique id that gets used for validation + linking inputs to their conditional container.
    if (id == "") {
        id = generateId();
        // Assign Id to input trigger
        context.attr(expressSelectors()['forms']['conditional-input'], id);
    }
    // Find conditional inputs container.
    let inputsContainer = $('[data-conditional-input-container=' + id + ']');
    // Fallback.
    if (inputsContainer.length == 0) {
        inputsContainer = context.parents('fieldset').find('.conditional-inputs');
        // Assign id to conditional input container..
        inputsContainer.each(function() {
            let container = $(this);
            // If there are multiple conditional inputs inside of this fieldset then only add the id to the one without an id.
            if (container.attr('data-conditional-input-container') == "") {
                container.attr('data-conditional-input-container', id);
            }
        });
        // Set the inputContainer as this get used for the abide validation later.
        inputsContainer = $('[data-conditional-input-container="'+ id +'"]');
    }
    // If conditional inputs container could not be found then exit.
    if (inputsContainer.length == 0) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(3,"Conditional Inputs: Could not find conditional input(s) container therefore exiting initialisation.");
        }
        return false;
    }

    // Made sure container has class.
    if (!inputsContainer.hasClass('conditional-inputs')) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(2,"Conditional Inputs: The conditional inputs container with this id = " + id + " does not have the conditional-inputs class, so this will be automatically assigned this should ideally be done in the source to prevent the content from jumping on page load.");
        }
        inputsContainer.addClass('conditional-inputs');
      }
    // Just in case the context has changed due to the fallbacks re-declare it.
    context = $('#' + context.attr('id'));
    // Check if form has abide validation active.
    if (form.attr('data-abide') != undefined) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Conditional Inputs: This form has abide validation initialising");
        }
        // Toggle form validation.
        let inputs = abideConditionalInput(inputsContainer);
    }
    // If toggle has a value on load then trigger the conditional inputs.
    if (getInputValue(context) != false) {
        $('[data-conditional-input-container=' + id + ']').addClass('active');
    }

    // If trigger changes then toggle conditional inputs container.
    context.on('change toggle-conditional-change', function() {
        let item = $(this);
        // Should we reset on change?
        let reset = (item.attr(expressSelectors()['forms']['conditional-reset']) != undefined);
        // Get conditional id.
        let conditionalId = item.attr(expressSelectors()['forms']['conditional-input']);
        // Is the conditional container active?
        const isContainerActive = inputsContainer.hasClass('active');
        // Get inputs.
        const inputs = inputsContainer.find('input, select, textarea');
        // if container was active then remove any form errors as they're nolonger applicable.
        if (isContainerActive) {
            if (AXISDebug.level() >= 4) {
                AXISDebug.output(1,"Conditional Inputs: inputs were previously active removing any form errors.");
            }
            inputs.each(function() {
                // Store input context.
                let input = $(this);
                // Make sure this form is validated by abide.
                if (form.data('abide') == undefined) {
                    return false;
                }
                // Reset all input / textarea values.
                if (reset) {
                    if (input.val() != "" && !input.is(':checkbox')) {
                        input.val("");
                    }
                    // Remove all checked properties.
                    if (input.is(':checkbox')) {
                        if (input.prop('checked')) {
                            input.prop('checked', false);
                            input.trigger('change');
                        }
                    }
                    // If select then select first option.
                    if (input.is('select')) {
                        input.val(input.find('option:first').val());
                    }
                }
                
                // Check if input has error.
                if (input.hasClass('is-invalid-input') || input.data('invalid') != undefined || input.attr('aria-invalid') == true) {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1,"Conditional Inputs: input " + input.attr('id') + " has form error disabling");
                    }
                    form.foundation('removeErrorClasses', input);
                }
            });
        }
        // Toggle container.
        $('[data-conditional-input-container=' + conditionalId + ']').toggleClass('active');

        abideConditionalInput(inputsContainer);

        context.trigger('conditional-change-complete', { active: !isContainerActive });
    });
}

// The actual functionality driving the conditional validation.
function abideConditionalInput(container) {
    // setTimeout(() => {
        // Get form context to remove error state from inputs.
        const form = container.closest('form');
        if (!container.hasClass('active') || container.css('display') == 'none') {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Form Validation: Conditional Inputs triggered excluding inputs from form validation.");
            }
            // No idea when I put all inputs into one each I ended up in a infinite loop.
            container.find('input').each(function() {
                let item = $(this);
                item.attr('data-abide-ignore', '');
                item.attr('tabindex', '-1');
                if (form.length) {
                    form.foundation('removeErrorClasses', item);
                }
            });
            container.find('select').each(function() {
                let item = $(this);
                item.attr('data-abide-ignore', '');
                item.attr('tabindex', '-1');
                if (form.length) {
                    form.foundation('removeErrorClasses', item);
                }
            });
            container.find('textarea').each(function() {
                let item = $(this);
                item.attr('data-abide-ignore', '');
                item.attr('tabindex', '-1');
                if (form.length) {
                    form.foundation('removeErrorClasses', item);
                }
            });
            container.find('a, button').each(function() {
                let item = $(this);
                // item.attr('disabled', '');
                item.attr('tabindex', '-1');
            });
            return true;
        } else {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Form Validation: Conditional Inputs triggered including inputs in form validation.");
            }
            container.find('input').each(function() {
                let item = $(this);
                item.removeAttr('data-abide-ignore');
                item.removeAttr('tabindex')
            });
            container.find('select').each(function() {
                let item = $(this);
                item.removeAttr('data-abide-ignore');
                item.removeAttr('tabindex')
            });
            container.find('textarea').each(function() {
                let item = $(this);
                item.removeAttr('data-abide-ignore');
                item.removeAttr('tabindex')
            });
            container.find('a, button').each(function() {
                let item = $(this);
                item.removeAttr('disabled', '');
                item.removeAttr('tabindex', '-1');
            });
            return true;
        }  
    // }, 0);
}

function formFieldPopup(context) {
    // Create popup;
    let popup = popupContainer(context);
    // Move content back to original position as vm is expecting form fields.
    context.appendTo($('.popup-original-position[popup-id=' + popup + ']'));
}

var formInstances = {};

function getFormInstanceId(context) {
    if (!context) {
        AXISDebug.output(3,"Video Player: No context provided");
        return false;
    }
    let id = context.attr('id');
    if (!id) {
        AXISDebug.output(3,"Video Player: No Id found, has this element been initialised?");
        return false;
    } else {
        return id;
    }
}

function setFormContext(id, value) {
    return formInstances[id]['context'] = value;
}

function getFormContext(id) {
    return formInstances[id]['context'];
}

function setFormBindedId(id, value) {
    return formInstances[id]['binded-id'] = value;
}

function getFormBindedId(id) {
    return formInstances[id]['binded-id'];
}

function setBindedFormContext(id, value) {
    return formInstances[id]['binded-context'] = value;
}

function getBindedFormContext(id) {
    return formInstances[id]['binded-context'];
}

function setFormInitialContent(id, value) {
    return formInstances[id]['initial-content'] = value;
}

function getFormInitialContent(id) {
    return formInstances[id]['initial-content'];
}

function formInitialise(context) {
    // Make sure form has an id.
    let formId = context.attr('id');
    // If form doesn't have id then assign one as this will cause issues with validation.
    if (!formId) {
        // Fallback to the name.
        const name = context.attr('name');
        if (name)  {
            // If name is provided add unique id to the end as there could be multiple forms with the same name ( i.e. list sorting ).
            formId = name + "-" + generateId();
        } else {
            // If the form has no name or id then generate.
            formId = "form-" + generateId();
        }
        context.attr('id', formId);
    }
    if (!formInstances.hasOwnProperty(formId)) {
        formInstances[formId] = {};
        setFormContext(formId, context);
    } else {
        return formId;
    }

    if (context.attr(expressSelectors()['forms']['data-bind'])) {
        const init = formDataBindInitialise(formId);
    }
    // If this form needs regenerate accordion tabs content.
    const accordionTabsUpdateId = context.attr(expressSelectors()['forms']['accordion-tabs-update']);
    // Get accordion tab's context.
    const accordionTabsContext = (accordionTabsUpdateId ? $('#' + accordionTabsUpdateId) : null);
    context.on('form-modified', (event, data) => {
        const currentId = event['currentTarget'].getAttribute('id');
        // If accordion tabs assigned then regenerate active tab.
        if (accordionTabsContext) {
            accordionTabsContext.trigger('accordion-pane-refresh');
        }
    });  
}

function formDataBindInitialise(id) {
    // Get context.
    const context = getFormContext(id);
    if (!context) {
        console.error("Form Bind: Please provide form context", context);
        return false;
    }
    // Get id / name of form that we're binding too.
    const bindedId = context.attr(expressSelectors()['forms']['data-bind']);
    setFormBindedId(id, bindedId);
    // Find the form.
    let bindedForm = $('form[id="' + bindedId + '"]');
    // If not found then fallback to name.
    if (!bindedForm.length) {
        bindedForm = $('form[name="' + bindedId + '"]');
        if (bindedForm > 1) {
            bindedForm = bindedForm.first();
        }
    }
    // If not found then exit.
    if (!bindedForm.length) {
        console.error("Form Bind: Failed to find binded form", context);
        return false;
    }
    setBindedFormContext(id, bindedForm);
    // Make sure parent is in sync with child.
    const merge = formDataBindMerge(id, 1);
    return merge;
}


/*

    Populate parent form with binded form's values.
    - id => instance id.
    - direction => 0 - Parent to Child, 1 - Child to Parent.

*/
function formDataBindMerge(id, direction = 0) {
    // Get context ( i.e. parent form ).
    const parentForm = getFormContext(id);
    // Get binded form. ( i.e. child form ).
    const childForm = getBindedFormContext(id);
    // Get inputs.
    const sourceInputs = (direction == 1 ? childForm.find('input, select, textarea') : parentForm.find('input, select, textarea'));
    // Flag to indicate if something was actually changed.
    let destinationChanged = false;
    // Determine the destination of where the merged content is injected.
    const destination = (direction == 1 ? parentForm : childForm);
    sourceInputs.each((index, sourceInput) => {
        // Source input type.
        const sourceType = sourceInput.type;
        // Get input name.
        const name = sourceInput.name;
        // Get input value.
        const value = (sourceType == "checkbox" ? sourceInput.checked : sourceInput.value);
        // Find destination input.
        const destinationInput = destination.find('[name="' + name + '"]');
        if (!destinationInput.length) {
            return;
        }
        // Destination input type.
        const destinationType = destinationInput[0].type;
        // Check if source element is a select as this will have implications on placeholders.
        const isSelect = ((direction == 1 ? destinationType : sourceType) == "select-one");
        // Check if checkbox.
        const isCheckbox = ((direction == 1 ? destinationType : sourceType) == "checkbox");
        // Check if radio button.
        const isRadioButton = ((direction == 1 ? destinationType : sourceType) == "radio");
        // Check if value different to destination value.
        const currentDestinationValue = destinationInput.val();
        if (currentDestinationValue != value) {
            // Update destination input value.
            if (destinationType == "hidden") {
                destinationInput.val(value);
            } else {
                if (isCheckbox) {
                    destinationInput.prop('checked', (value == "true"));
                } else if(isRadioButton) {
                    destination.find('input[name="' + name + '"][value="' + value + '"]').prop('checked', true);
                } else {
                    destinationInput.val(value);
                    // Fire change event.
                    if (isSelect) {
                        $(destinationInput).parents('.control').trigger('control-value-updated');
                    }
                }
            }      
            destinationChanged = true;  
            // Find any placeholders.
            const placeholders = destination.find('[' + expressSelectors()['forms']['data-bind-placeholder'] + '="' + name + '"]');
            // If placeholders exist then update.
            if (placeholders.length) {
                // If a select then get the selected text as this will be human readable, otherwise just use the raw value.
                let placeholderText = value;
                // Some inputs will require additional processing to get the value in a user friendly form.
                if (isCheckbox) {
                    placeholderText = (value ? "Yes" : "No");
                } else if (isRadioButton) {
                    if (sourceInput.checked != true) {
                        return;
                    }
                } else if (isSelect) {
                    placeholderText = sourceInput.options[sourceInput.selectedIndex].text;
                }
                placeholders.html(placeholderText);
            }
        }
    });
    if (destinationChanged) {
        destination.trigger('form-modified', {
            'id': id,
            "changed-by": "form-bind"
        });
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Form Bind: Has destination input(s) changed:", (destinationChanged ? "yes" : "no"));
        }
    }
    return {
        'id': id,
        'success': true
    };
}

function initaliseAllForms() {
    $('form').each(function() {
        let context = $(this);
        let initalise = formInitialise(context);
    });
}

function disabledButtonsInitialise(context) {
    // If context is defined then this is most likely a ajax function call.
    if (context) {
        context.find('button.disabled, a.disabled, a[disabled]').on('click',function(event) {
            event.preventDefault();
            // Put button into context.
            let button = $(this);
            disabledButtons(button);
        });
    } else {
        // Normally used on page load.
        $('button.disabled, a.disabled, a[disabled]').on('click',function(event) {
            event.preventDefault();
            // Put button into context.
            let button = $(this);
            disabledButtons(button);
        });
    }
}

// Because we shouldn't really be disabling buttons without giving a reason.
function disabledButtons(button) {
    // Run a check to see if button is still disabled since initialation and if there is an abide error present then dont worry about outputting the invalid reason.
    if ((button.hasClass('disabled') || button.attr('disabled') != undefined) && button.parents('form').find('[data-abide-error]').length == 0 || button.attr('readonly')) {
        return invalidReason(button);
    } else {
        return false;
    }
}

function invalidReason(context) {
    // Find reason, using the old attribute.
    let reason = context.attr(expressSelectors()['forms']['controls']['invalid-reason']);
    // Fallback.
    if (reason == undefined || reason == "") {
        reason = context.parents('['+ expressSelectors()['forms']['controls']['invalid-reason'] + ']').attr(expressSelectors()['forms']['controls']['invalid-reason']);
    }

    // Fallback #2 ( THE PREFERED WAY OF DOING THIS )
    if (!reason) {
        reason = getRestrictedWarning(context);
        // Final fallback #3 use the title.
        // let title = context.attr('title');
        // if (title.length) {
        //     reason = title;
        // }
    }

    if (reason == undefined) {
        AXISDebug.output(2,"Inputs: We shouldn't be disabling buttons without giving some sort of visual reason as that leads to a poor user expierence.");
        return false;
    } else {
        // Create notification.
        callouts.create(reason, 2);
        return false;
    }
}

// Run abide validation.
function validateForm(context) {
    // Check whether form is running abide.
    let isAbide = isAbideEnabled(context);
    
    if (isAbide) {
        return context.foundation('validateForm');
    } else {
        return true;
    }
}


function addClassListeners() {
    // TODO: this needs to be modified to use the label not the in put.


    $('body').on('focusin focusout focus mouseenter mouseleave change', '.control', function(event) {
        // Grab Context.
        let context = $(this);
        // Get input.
        let input = context.find('input, select, textarea');
        // Make sure we have the label in context.
        if (!input) {
            AXISDebug.output(3,"Axis Inputs: Failed to obtain input for ", context);
            return false;
        }

        // Get event type.
        let eventType = event['type'];
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Axis Inputs: Added class to input parent for the following event", eventType);
        }
        
        switch (eventType) {
            case "mouseenter":
                context.addClass('is-hovered');
                input.addClass('hover');
                break;
            case "mouseleave": 
                context.removeClass('is-hovered');
                input.removeClass('hover');
                break;
            case "focusin":
                context.addClass('is-focused');
                input.addClass('focus');
                break;
            case "focusout": 
                context.removeClass('is-focused');
                input.removeClass('focus');
                break;
            default:
                // No event fired for the following so having to react on change.
                if (input.attr('disabled') || input.prop('disabled')) {
                    context.addClass('disabled-input');
                    input.addClass('disabled');
                } else if (context.hasClass('is-disabled') || context.hasClass('disabled-input')) {
                    context.removeClass('disabled-input');
                    input.removeClass('disabled');
                }
        }
    });
}

// At the moment this only affects select dropdowns.
function fireControlResetEvents(context) {
    if (!context) {
        return false;
    }
    if (context.attr('control-select-id')) {
        context.trigger('control-reset');
    }
}

$(document).on('reset', 'form', function(event) {
    // Form context.
    let form = $(this);
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Axis Inputs: A form has be reset, triggering control reset events.", form);
    }
    // Does it container any control elements?
    let controlElements = form.find('.control');
    if (controlElements.length) {
        controlElements.each(function() {
            // Element context.
            let control = $(this);
            // Reset it.
            fireControlResetEvents(control);
        });
    }
});

// Used to give an input a unique value with generateId().
function inputsUniqueValue() {
    const inputs = $('[' + expressSelectors()['forms']['input-unique-value'] + ']');
    if (inputs.length) {
        inputs.each(function() {
            // Input context.
            const context = $(this);
            // Get original value.
            let value = context.val();
            // Generate unique value.
            let unique = generateId(8);
            // If already has a value then use that a prefix.
            if (value.length) {
                value = value + unique;
            }
            // Update DOM.
            context.val(value);
            context.prop('value', value);
        });
    }
}

var AXISInputs = $.AXISInputs = {
    initialise: () => {
        controlInitialiseAll();
        if ($('.advanced-validation').length > 0) {
            $('.advanced-validation').each(function() {
                let context = $(this);
                advancedValidation(context);
            });
        }
        initialiseAllDisabledInputs()
        initaliseAllForms();
        inputsListeners();
        disabledButtonsInitialise();
        // Inputs that get revealled by conditions ( e.g registration & manage users )
        initialiseAllConditionalInputs();
        // Inputs that restrict other elements / inputs.
        restrictedContentInitialiseAll();
        // TODO: Deprecated.
        //let toggleableInput = toggleableInputsInitialiseAll();
        groupedInputsInitialiseAll();

        controlRadioButtons();

        addClassListeners();

        inputsUniqueValue();
    },
    revalidate: (formContext) => {
        let abide = abideRestart(formContext);
        return abide;
    },
    validationInitialise: (formContext) => {
        let abide = abideStart(formContext);
        return abide;
    },
    initialisePasswordReveal: (context) => {
        let initialise = initialisePasswordReveal(context);
        return initialise;
    },
    formFieldPopup: (context) => {
        // TODO: This will most likely need to be reworked due to how we have developed modals.
        let initalise = formFieldPopup(context);
        return initalise;
    },
    inputDisabledInitialise: (context) => {
        return inputDisabled(context);
    },
    inputDisabledKill: (context) => {
        return inputDisabledKill(context);
    },
    buttonDisabledInitialise: (context) => {
        return anchorDisabled(context);
    },
    buttonDisabledKill: (context) => {
        return anchorDisabledKill(context);
    },
    initialiseControlInputs: (context) => {
        
        // Typically used to intialise inputs after ajax that dont have the appropriate class assigned to their label containers for example .control.text or .control.select.

        // Looks for any conditional inputs.
        context.find("[" + expressSelectors()['forms']['conditional-input'] + "]").each(function() {
            let context = $(this);
            let initialise = conditionalInputToggleInitialise(context);
        });


        return control(context);
    },
    initaliseControlSelect: (context) => {
        // TODO: This should not be used instead use initialiseControlInputs.
        return controlSelectInitialise(context);
    },
    initialiseControlRadios: (context) => {
        return controlRadioButtons(context);
    },
    disabledButtonsInitialise: (context) => {
        if (!context) {
            AXISDebug.output(3," Disabled Buttons: No context defined if this function is being called as a result of an ajax callback then you need to provide a context otherwise every disabled button/anchor will be re-initialised.");
        } 
        return disabledButtonsInitialise(context);
    },
    disabledButtons: (context) => {
        return disabledButtons(context);
    },
    invalidReason: (context) => {
        return invalidReason(context);
    },
    validateInput: (context, required) => {
        if (!isAbideEnabled(context)) {
            return false;
        }
        return vmValidation(context, required);
    },
    isAbideEnabled: (context) => {
        return isAbideEnabled(context);
    },
    validationOutput2: (context, state) => {
        return validationOutput2(context, state);
    }, 
    validateForm: (context) => {
        return validateForm(context);
    }, 
    groupedInputsInitialise: (context) => {
        // Used to initialise function after ajax.
        return groupedInputsInitialise(context);
    },
    inputsUniqueValue: () => {
        return inputsUniqueValue();
    },
    formDataBindMerge: (context, direction) => {
        const id = getFormInstanceId(context);
        if (id) {
            return formDataBindMerge(id, direction);
        } else {
            return false;
        }
    }
}

export { AXISInputs }

//Globalise AJAX functionality.
window.AXISInputs = AXISInputs;